// 繁體中文（香港）。
//
// 用香港學校日常嘅講法，唔係直譯 —— 「Class」係「班別」唔係「班級」，「No.」係「學號」，
// 「Staff」喺職務欄係「負責人」。一個學校職員睇落去應該覺得係佢哋自己嗰套用語。
//
// 中文冇單複數，所以計數嘅條目係一條字串就夠 —— `{ one, other }` 嗰個形狀留返畀英文。
// 任何未譯嘅 key 會顯示英文，唔會顯示 key 本身。

export default {
  common: {
    save: '儲存',
    saving: '儲存中…',
    saved: '已儲存',
    cancel: '取消',
    close: '關閉',
    delete: '刪除',
    remove: '移除',
    edit: '編輯',
    add: '新增',
    search: '搜尋',
    filter: '篩選',
    loading: '載入中…',
    confirm: '確認',
    submit: '提交',
    yes: '是',
    no: '否',
    all: '全部',
    none: '無',
    date: '日期',
    time: '時間',
    name: '姓名',
    className: '班別',
    classNumber: '學號',
    student: '學生',
    students: '學生',
    staff: '職員',
    remarks: '備註',
    status: '狀態',
    actions: '操作',
    schoolYear: '學年',
    allSchoolYears: '所有學年',
    allClasses: '所有班別',
    selectStudent: '— 請選學生 —',
    import: '匯入',
    export: '匯出',
    template: '範本',
    print: '列印',
    refresh: '重新整理',
    signOut: '登出',
    notSet: '未設定',
    nothingYet: '暫時未有記錄',
    noMatch: '沒有符合的記錄',
    clearFilters: '清除篩選',
    selectedCount: '已選 {count} 項',
    studentCount: '{count} 位學生',
  },

  language: {
    label: '語言',
    english: 'English',
    traditionalChinese: '繁體中文',
  },

  nav: {
    commonlyUsed: '常用',
    sections: {
      me: '我的工作',
      students: '學生事務',
      assessments: '評估',
      administration: '行政',
      duties: '職務安排',
      booking: '預約',
      accounting: '會計',
      resources: '資源',
      system: '系統',
    },
    modules: {
      my_notice: '我的通告',
      my_attendance: '我的考勤',
      my_talent_bank: '我的才能檔案',
      my_messages: '我的訊息',
      dashboard: '主頁',
      my_duties: '我的職務',
      my_timetable: '我的時間表',
      my_message: '我的訊息',
      forms_and_application: '表格與申請',
      attendance: '考勤',
      social_credit: '學生獎懲',
      ole_management: '其他學習經歷',
      talent_bank: '才能檔案',
      parent_notice: '通告與繳費',
      seating_plan: '座位表',
      exam_scope: '考試範圍',
      assessment: '成績記錄',
      quiz_tutorial: '測驗與補課',
      calendar_admin: '校曆表',
      teacher_timetable: '教師時間表',
      timetable_profiles: '時間表設定',
      substitution: '代課',
      teaching_duty: '科組',
      manpower_allocation: '行政職務',
      invigilation: '監考',
      sen_invigilation: 'SEN 監考',
      patrol_duty: '巡邏職務',
      facility_booking: '場地預約',
      borrow_devices: '借用資訊器材',
      budget_control: '財政預算',
      inventory_admin: '物資管理',
      salary_audit: '薪酬核算',
      campus_management: '校舍',
      manage_it_assets: '資訊資產',
      inventory_user: '我的物資',
      maintenance_report: '維修報告',
      user_mgmt: '職員帳戶',
      data_mgmt: '學生帳戶',
      system_groups: '權限管理',
      system_settings: '系統設定',
    },
  },

  // ── 學生同家長睇到嘅四個畫面 ──────────────────────────────────────────────────────────────
  // 呢四個先譯，因為佢哋係全個平台上面唯一一批可能唔讀得英文嘅人。

  family: {
    guardianOf: '{names} 的家長',
    noChildLinked: '此家長帳戶尚未連結到任何學生記錄。如果子女是剛剛加入，最多可能要等一小時才會顯示，或登出再登入。',
    noChildLinkedShort: '此家長帳戶尚未連結到任何學生記錄。',
    noOwnRecordShort: '你的帳戶尚未連結到學生記錄。',
    noOwnRecord: '你的帳戶尚未連結到學生記錄。請聯絡學校校務處查核。',
    child: '子女',
    student: '學生',
    nothingYet: '暫時未有記錄',
  },

  myNotice: {
    settledVia: {
      kpay_online: 'K-Pay（網上）',
      kpay_octopus: 'K-Pay（在學校拍八達通）',
      school_override: '由學校記錄',
    },
    tabs: {
      toSign: '待簽署',
      notices: '通告',
      payments: '繳費',
      examScope: '考試範圍',
    },
    nothingPending: '暫時沒有項目需要處理。',
    noticesToSign: '待簽署通告',
    noticesForGuardian: '需要家長簽署的通告',
    guardianIntro: '發給你子女的通告。在這裡簽署即表示你已經知悉。',
    studentIntro: '你可以閱讀所有發給你的通告。簽署要由家長在他們自己的帳戶處理。',
    signedByGuardian: '本份通告由家長在他們自己的帳戶簽署。',
    paidByGuardian: '本筆費用由家長在他們自己的帳戶繳付。',
    sign: '簽署本份通告',
    signing: '簽署中…',
    signFailed: '簽署不到本份通告：{message}',
    payOnline: '用 K-Pay 網上繳費',
    payOctopus: '或用現金增值八達通，再在學校的拍卡機拍卡 —— K-Pay 確認了之後此一項就會自動更新。',
    kpayHandsOff: '連接之後，這裡會轉去 K-Pay 繳付 ${amount}。',
    levelOnly: '只看{level}',
    kpayNotConnected: 'K-Pay 尚未連接。',
    kpayConfirms: '繳費由 K-Pay 自己確認 —— 本應用程式不會自行將費用標記為已繳。',
    recordedBySchool: '由學校記錄',
    scopeTitle: '溫習範圍',
    scopeIntro: '各科為即將來的測考所訂的溫習範圍，由學校發布 —— 仍在草擬中的不會在這裡顯示。',
    scopeNothing: '暫時未有發布。',
    allLevels: '所有級別',
  },

  myAttendance: {
    signedInAt: '你今早已經於 {time} 簽到。',
    signedOutAt: '你今日已經於 {time} 簽走。',
    parentViewIntro: '{name} 的簽到記錄。只有學生本人可以簽到。',
    parentViewYourChild: '你的子女',
    checkedInToday: '你今日已經簽到了 {count} 次。',
    scanToCheckIn: '掃碼考勤',
    scanButton: '掃描 QR 碼',
    scanning: '考勤中…',
    scanIntro: '掃描老師顯示的 QR 碼即可考勤。每個碼五分鐘後失效。',
    studentsOnly: '只有學生可以自行考勤。',
    noCamera: '此部裝置找不到鏡頭，所以在這裡考勤不到。',
    noCameraShort: '此部裝置找不到鏡頭。',
    cameraFailed: '無法使用鏡頭：{message}',
    cardTitle: '你的考勤卡',
    cardIntro: '與你印製的卡上的碼相同。如果沒有帶卡，可以出示給手持掃描器的職員。',
    cardAlt: '你的考勤卡 QR 碼',
    noRecords: '暫時未有考勤記錄。',
    method: '方式',
    confirmed: '已確認',
    awaitingConfirmation: '等待確認',
    checkedIn: '已考勤，老師會作出確認。',
    checkInFailed: '考勤不到：{message}',
    qrNotValid: '此不是有效的考勤 QR 碼。',
    qrOtherSchool: '此 QR 碼屬於另一間學校。',
    qrUnverified: '此 QR 碼核實不到。請掃描老師正在顯示的碼。',
    qrExpired: '此 QR 碼已經失效。請掃描最新該。',
    qrCheckFailed: '現在核實不到此 QR 碼，請再試一次。',
  },

  myMessages: {
    allMessages: '所有訊息',
    none: '暫時未有訊息。學校需要聯絡你的時候，會在這裡開始對話。',
    selectOne: '請選一個對話。',
    unread: '新',
    reply: '輸入回覆…',
    send: '傳送',
    sending: '傳送中…',
    sendFailed: '傳送不到：{message}',
    gone: '此對話已經不存在。',
  },

  myDuties: {
    tabs: {
      upcoming: '即將舉行',
      substitution: '代課',
      roles: '我的職位',
      patrolPreference: '巡邏意向',
    },
    kinds: {
      invigilation: '監考',
      sen_invigilation: 'SEN 監考',
      patrol: '巡邏',
      covering: '代課',
      covered: '缺席 — 已安排代課',
    },
    upcoming: '即將',
    past: '過往',
    refresh: '重新整理',
    arrangedDuringDay: '代課有機會在當日先安排',
    noneAssigned: '暫時未有職務安排給你。',
    nonePast: '過往沒有記錄。',
    noneUpcoming: '未有即將來的安排。',
    runningOrder: '流程表',
    inThisRoom: '此間房的學生',
    roomNotSet: '此間房尚未設定流程表或學生。',
    matchedByInitial: '其中 {count} 項是用你的英文縮寫而不是帳戶對應出來。顯示的內容全部正確，但只用縮寫識別的記錄，保安規則保護不到。請聯絡管理員在 Developer Portal 執行「{task}」。',
    stampTask: 'Stamp duty addresses',
    noKindPast: '過往沒有{kind}記錄。按「全部」查看其餘的。',
    noKindUpcoming: '未有即將來的{kind}。按「全部」查看其餘的。',
    asRecorded: '學校記錄的數字',
    earned: '合共加 {n} 分',
    deducted: '合共扣 {n} 分',
    balance: '結餘',
    lessonsCovered: '已代課節數',
    absences: '缺席',
    covered: '已代課',
    absent: '缺席',
    noRecords: '暫時未有記錄。',
    balanceDiffers: '下面的記錄加起來是 {ledger}，但學校記錄的結餘為 {recorded}。兩個數字照原樣顯示。如果此差異有影響，請聯絡代課統籌 —— 由匯入產生的記錄是其中一個常見原因。',
    noPosts: '你今個學年沒有擔任教學或行政職位。',
    teaching: '教學',
    administrative: '行政',
    patrolIntro: '你希望負責哪些巡邏時段。此只是意向，不是預約 —— 巡邏統籌仍然負責編更，而你在這裡選擇的就是它編更時見到的項目。',
    noPatrolSessions: '巡邏統籌尚未設定任何時段。',
    patrolSaveFailed: '無法儲存你的意向：{message}',
    examination: '考試',
    specialRoom: '特別室',
    coverDuty: '代課',
    yourLesson: '你的課堂',
    absence: '缺席',
  },

  myTimetable: {
    title: '我的時間表',
    noYear: '未有學年',
    chooseTeacher: '— 請選擇教師 —',
    selectTeacher: '請選擇一位教師以檢視其時間表。',
    period: '節',
    recess: '小息',
    lunch: '午膳',
    lesson: '課堂',
    break: '小息',
    admin: '行政',
    afterschool: '放學後',
  },

  myMessage: {
    tabs: {
      messages: '我的訊息',
      messagesWithCount: '我的訊息（{count}）',
      groups: '訊息群組',
    },
    newMessage: '新訊息',
    newGroup: '新群組',
    newGroupChat: '新群組對話',
    editGroup: '編輯群組',
    saveGroup: '儲存群組',
    groupName: '群組名稱',
    groupNamePlaceholder: '例如：中一班主任',
    noMatches: '沒有符合的結果。',
    noThreadsStudent: '暫時未有訊息。學校職員會在這裡和你開始對話。',
    noThreadsStaff: '暫時未有對話。按「新訊息」開始一個。',
    selectOne: '請選一個對話。',
    back: '返回',
    unread: '未讀',
    fromYou: '你：{snippet}',
    fromSomeone: '{name}：{snippet}',
    participants: '{count} 位參與者',
    write: '輸入訊息…',
    send: '傳送',
    sending: '傳送中…',
    saving: '儲存中…',
    sendFailed: '傳送不到：{message}',
    saveGroupFailed: '無法儲存群組：{message}',
    deleteFailed: '刪除不到：{message}',
    gone: '此對話已經不存在。',
    groupNeedsMembers: '群組需要一個名稱和至少一位成員。',
    deleteGroupConfirm: '確定刪除群組「{name}」？已經開始了的對話不會受影響。',
    groupsIntro: '群組是選擇人入對話的捷徑。三個內建群組會即時由職員同學生名單計算出來，所以永遠不需要維護。',
    memberCount: '{count} 位成員',
    builtIn: '內建',
    you: '你',
    readBy: '{count} 人已讀',
    participantsHeading: '參與者（{count}）',
    participantsLabel: '參與者（{count}）',
    members: '成員（{count}）',
    addGroup: '＋ 加入群組…',
    addClass: '＋ 加入班別…',
    clearAll: '全部清除',
    clear: '清除',
    searchPeople: '搜尋職員、學生或班別…',
    searchStaffStudents: '搜尋職員或學生…',
    subject: '主旨',
    optional: '選填',
    message: '訊息',
    groupChatWarning: '此會開一個群組對話。所有加入的人都看到其他參與者，亦讀取每一則回覆。',
    predefined: {
      __all_staff: '全體職員',
      __all_teachers: '全體教師',
      __all_students: '全體學生',
    },
  },

  login: {
    fallbackName: '學校平台',
    fallbackTagline: '安全登入',
    welcome: '歡迎使用{name}',
    developerName: '開發者管理',
    developerTagline: '只限超級管理員',
    logoAlt: '學校標誌',
    emailAddress: '電郵地址',
    password: '密碼',
    signIn: '登入',
    signingIn: '登入中…',
    or: '或',
    googleSignIn: '用 Google 登入',
    parentPrompt: '家長或監護人？免密碼登入',
    staffPrompt: '職員及學生登入',
    parentIntro: '請輸入學校為你登記的電郵地址。我們會寄一條登入連結給你 —— 不需要記密碼。',
    emailPlaceholder: 'you@example.com',
    sendLink: '寄登入連結給我',
    sending: '傳送中…',
    linkSentLead: '請查閱你的收件箱。我們已經寄了一條登入連結去 ',
    linkSentEnd: '。',
    linkOnce: '請在此部裝置開啟 —— 條連結只可以用一次，而且只在提出要求該瀏覽器有效。',
    notArrivedLead: '收不到？',
    notArrived: '請檢查垃圾郵件。訊息由學校的登入服務寄出，部分電郵供應商第一次會將它分類到該處。',
    differentAddress: '用另一個電郵地址',
    confirmEmail: '請確認你的電郵地址以完成登入',
    needEmail: '請輸入你的電郵地址。',
    emailNeededToFinish: '需要你的電郵地址先完成到登入。請重新索取連結。',
    linkUsed: '條連結已經用了或過了期。請重新索取。',
    linkFailed: '寄不到連結。請檢查電郵地址再試。',
    invalidCredential: '登入資料不正確',
    noDeveloperAccess: '你沒有開發者權限。',
    verifyFailed: '核對應不到你的學校。請再試一次。',
    unknownSchool: '不認得此學校網址。',
    notRegistered: '此帳戶未在本校登記。請聯絡學校管理員。',
    passwordlessOff: '此平台尚未開啟免密碼登入。Firebase Console \u2192 Authentication \u2192 Sign-in method \u2192 Email/Password \u2192 開啟 "Email link (passwordless sign-in)"。',
    domainNotAuthorised: '本校的網址（{host}）不在授權網域名單內。Firebase Console \u2192 Authentication \u2192 Settings \u2192 Authorized domains。不支援萬用字元，所以每個學校子網域都要逐個加。',
  },

  familyNav: {
    sections: '分頁',
    signOut: '登出',
  },

  dashboard: {
    weatherLoading: '載入中…',
    weatherUnavailable: '無法取得',
    comingUp: '即將舉行',
    fullCalendar: '完整日曆',
    embeddedCalendar: '嵌入日曆',
    embeddedCalendarTitle: '嵌入的學校日曆',
    configure: '設定',
  },

  agenda: {
    titles: {
      school: '校曆',
      ole: '活動',
      invigilation: '考試',
      patrol: '巡邏',
      substitution: '代課',
      tutorial: '補課',
      booking: '預約',
      notice: '通告',
    },
    cycleDay: '循環日 {day}',
    staffAway: '{staff} 請假',
    studentCount: '{count} 位學生',
    fromParentNotice: '來自家長通告',
    bookingRoom: '場地',
    bookingDevice: '器材',
    bookingTitle: '{kind}：{what}',
    previousMonth: '上一個月',
    nextMonth: '下一個月',
    today: '今日',
    everything: '全部',
    mine: '我的',
    mineTag: '我的',
    refresh: '重新整理',
    weekdays: { sun: '日', mon: '一', tue: '二', wed: '三', thu: '四', fri: '五', sat: '六' },
    more: '尚有 {count} 項',
    backToDay: '返回當日',
    itemCount: '{count} 項',
    todayPrefix: '今日',
    nothingOnDay: '此日沒有任何項目。',
    youAreOnThis: '你有份參與。',
    whoIsOnThis: '參與者',
    nobodyListed: '暫時未有人列在本項活動。',
    noParticipantList: '此類項目沒有參與者名單。',
    sources: {
      school: '學校日曆',
      ole: 'OLE 活動',
      invigilation: '監考',
      patrol: '巡邏',
      substitution: '代課',
      absence: '缺席',
      tutorial: '補課',
      booking: '場地預約',
      notice: '通告日期',
    },
  },

  install: {
    title: '將本平台加到主畫面',
    why: '開啟時似一個應用程式，沒有網址列，通告亦都會經這裡通知你。',
    install: '安裝',
    showMeHow: '教我點做',
    notNow: '暫時不需要',
    dismiss: '關閉',
    installApp: '安裝應用程式',
    iosShare: '按 Safari 底部的「分享」',
    iosAdd: '選擇「加入主畫面」',
  },

  push: {
    on: '通知已開啟',
    turnOn: '開啟通知',
    installFirst: '請先將本平台加到主畫面，之後先收到通知。',
    blocked: '此網站的通知已被封鎖。請在瀏覽器的網站設定裡面重新開啟。',
    failed: '無法開啟通知。請稍後再試。',
  },

  myCalendar: {
    title: '我的學校時間表',
    notInAcademicYear: '不在學年範圍內',
    timetableProfile: '時間表設定',
    noTimetable: '未編配時間表',
    dailySchedule: '每日時間表',
    noPeriods: '此日沒有編排任何節數。',
    dayTypes: {
      schoolday: '上課日',
      schoolholiday: '學校假期',
      publicholiday: '公眾假期',
      weekend: '週末',
      functionday: '活動日',
    },
    periodTypes: {
      lesson: '課節',
      break: '小息',
      admin: '行政',
      afterschool: '放學後',
    },
  },

  inventoryUser: {
    tab: '我的物資',
    assigned: '已編配物資',
    loading: '載入物資中…',
    none: '暫時沒有物資編配給你。',
    category: '類別：',
    quantityAssigned: '編配數量：',
    lastStocktake: '上次盤點：',
    never: '從未',
    confirmPossession: '確認持有及狀況良好',
    reportDiscrepancy: '申報差異／註銷',
    inactive: '此物品目前狀態為{status}，沒有可執行的操作。',
    stocktakeConfirm: '確認你持有 {quantity} 件「{name}」而且狀況良好？',
    stocktakeDone: '盤點已確認！',
    submitApplication: '提交申請',
    itemLabel: '物品：',
    applicationType: '申請類別',
    typeDiscrepancy: '申報遺失／差異',
    typeWriteOff: '申請註銷（損壞／不能使用）',
    typeReplacement: '申請更換',
    remarks: '備註及詳情',
    remarksPlaceholder: '請說明差異情況、需要註銷的原因，或為何要更換…',
    submit: '提交',
    submitted: '申請已提交待審批。',
    error: '錯誤：{message}',
    statuses: {
      active: '使用中',
      inactive: '停用',
      needsrepair: '需要維修',
      needsreviewdiscrepancy: '需要覆核（差異）',
      writtenoff: '已註銷',
    },
  },

  facilityBooking: {
    tabs: {
      facilities: '場地',
      myBookings: '我的預約',
    },
    searchFacilities: '搜尋可用場地…',
    loadingFacilities: '載入場地中…',
    noFacilities: '找不到可用場地。',
    capacity: '容量：',
    approval: '審批：',
    approvalAuto: '自動',
    approvalManual: '人手',
    requestBooking: '申請預約',

    noHistory: '你未有任何預約紀錄。',
    upcoming: '即將到來的預約',
    past: '過往預約',
    requested: '申請於：',
    justNow: '剛剛',
    cancelBooking: '取消',
    cancelConfirm: '確定要取消此申請？',
    cancelFailed: '取消不到：{message}',
    statuses: {
      approved: '已批准',
      pending: '待審批',
      rejected: '已拒絕',
      completed: '已完成',
    },

    bookTitle: '預約 {lid} - {name}',
    slotsSelected: '已選擇 {count} 個時段',
    showFullDay: '顯示全日',
    showTimetableOnly: '只顯示課節',
    today: '今日',
    back: '上一週',
    next: '下一週',
    time: '時間',
    booked: '已預約',
    pastSlot: '已過',
    available: '可用',
    full: '已滿',
    dayLetters: { sun: '日', mon: '一', tue: '二', wed: '三', thu: '四', fri: '五', sat: '六' },

    selectedConfig: '已選時段設定',
    invalidSlot: '時間不正確或已被佔用。',
    startTime: '開始時間',
    endTime: '結束時間',
    remarksOptional: '備註（選填）',
    remarksPlaceholder: '如有其他資料想俾管理員知，可以在這裡寫…',
    submitRequests: '提交 {count} 個申請',

    cannotBookPast: '不可以預約已經過了的時段。',
    slotTaken: '此時段已經有人預約了。',
    selectOneSlot: '請最少選一個課節時段。',
    exceedsAvailability: '有一個或以上已選的申請超出可用數量，或時間不正確。請調整。',
    bookingSuccess: '預約成功！',
    requestSubmitted: '申請已提交，等待管理員審批。',
  },

  mdmUser: {
    tabs: {
      devices: 'IT 裝置／帳戶',
      myBookings: '我的預約',
    },
    searchAssets: '搜尋可用資產…',
    loading: '載入物資中…',
    noAssets: '找不到可用資產。',
    type: '類型：',
    approval: '審批：',
    approvalAuto: '自動',
    approvalManual: '人手',
    requestBorrow: '申請借用',

    noHistory: '你未有任何預約紀錄。',
    upcoming: '即將到來的預約',
    past: '過往預約',
    requested: '申請於：',
    justNow: '剛剛',
    cancelBooking: '取消',
    cancelConfirm: '確定要取消此申請？',
    cancelFailed: '取消不到：{message}',
    statuses: {
      reserved: '已預留',
      pending: '待審批',
      rejected: '已拒絕',
      completed: '已完成',
      returned: '已歸還',
    },

    borrowTitle: '借用 {name}',
    requestedQuantity: '申請數量：',
    slotsSelected: '已選擇 {count} 個時段',
    showFullDay: '顯示全日',
    showTimetableOnly: '只顯示課節',
    today: '今日',
    back: '上一週',
    next: '下一週',
    time: '時間',
    pastSlot: '已過',
    availableCount: '可用：{count}',
    full: '已滿',
    dayLetters: { sun: '日', mon: '一', tue: '二', wed: '三', thu: '四', fri: '五', sat: '六' },

    selectedConfig: '已選時段設定',
    invalidSlot: '時間不正確或可用數量不足。',
    startTime: '開始時間',
    endTime: '結束時間',
    submitRequests: '提交 {count} 個申請',

    cannotBookPast: '不可以預約已經過了的時段。',
    notEnoughQuantity: '此時段的可用數量不足。最多可借：{max}',
    selectOneSlot: '請最少選一個課節時段。',
    exceedsQuantity: '有一個或以上已選的申請超出可用數量，或時間不正確。請調整。',
    borrowSuccess: '借用成功！',
    requestSubmitted: '申請已提交，等待管理員審批。',
  },

  attendance: {
    halves: {
      in: '簽到',
      out: '簽走',
    },
    signedInAt: '你今早已經於 {time} 簽到。',
    signedOutAt: '你今日已經於 {time} 簽走。',
    alreadySignedIn: '{name} 已經於 {time} 簽到。',
    alreadySignedOut: '{name} 已經於 {time} 簽走。',
    halfCutoff: '上午結束於',
    halfCutoffHint: '在此時間之前掃碼算簽到，由此時間開始算簽走。每人每日各一次。',
    badCutoff: '請用 HH:MM 格式輸入時間，例如 12:00。',
    signOutCol: '簽走',
    noSignOut: '未簽走',
    selectStudent: '— 請選學生 —',
    tabs: {
      myAttendance: '我的考勤',
      teacher: '教師',
      staff: '職員',
      student: '學生',
      leave: '請假',
      settings: '設定',
      qr: 'QR 碼',
      scan: '掃描',
      cards: '卡片',
    },
    addRecord: '新增紀錄',
    exportCsv: '匯出 CSV',
    confirmAll: '全部確認',
    noYears: '未設定學年',
    saveSettings: '儲存設定',

    name: '姓名',
    time: '時間',
    method: '方式',
    qrId: 'QR 編號',
    ipAddress: 'IP 位址',
    verifiedCol: '已核實',
    pendingVerification: '未核實',
    actions: '操作',
    unknownIp: '未知',
    verified: '已核實',
    pending: '待核實',
    verify: '核實',

    myTitle: '我的考勤',
    myTitleYear: '我的考勤（{year}）',
    scanQr: '掃描 QR 碼',
    manualCheckIn: '手動簽到',
    noCameraTitle: '此部裝置找不到相機。',
    noCameraStudent: '此部裝置找不到相機。',
    noCameraStaff: '此部裝置找不到相機 —— 請改用手動簽到。',
    dateTime: '日期／時間',
    noRecordsThisYear: '此學年暫時未有考勤紀錄。',
    pointCamera: '請將相機對準畫面上顯示的考勤 QR 碼。',

    teacherTitle: '教師考勤 —— {date}',
    staffTitle: '職員考勤 —— {date}',
    studentTitle: '學生考勤 —— {date}',
    noTeacherRecords: '此日沒有教師考勤紀錄。',
    noStaffRecords: '此日沒有職員考勤紀錄。',
    noStudentRecords: '此日沒有學生考勤紀錄。',
    noRecords: '沒有紀錄。',
    recordCount: '（{count} 項紀錄）',

    leaveTitle: '請假核對 —— {date}',
    peopleCount: '{count} 人',
    withoutAttendance: '{count} 人沒有考勤紀錄',
    confirmedCount: '{count} 人已確認',
    notSchoolDay: '{date} 在 {year} 的校曆裡面不是上課日。',
    noStaffProfiles: '找不到職員檔案。',
    initial: '縮寫',
    type: '類別',
    checkIn: '簽到',
    status: '狀態',
    leaveType: '假期類別',
    remark: '備註',
    confirmedCol: '已確認',
    noRecord: '沒有紀錄',
    confirmed: '已確認',
    leaveSaved: '請假紀錄已儲存。',
    leaveConfirmed: '請假紀錄已確認。',
    leaveStatuses: {
      present: '出席',
      late: '遲到',
      earlyleave: '早退',
      absent: '缺席',
      onleave: '放假',
    },
    leaveTypes: {
      sickleave: '病假',
      annualleave: '年假',
      nopayleave: '無薪假',
      officialduty: '公務',
      maternitypaternity: '產假／侍產假',
      compensationleave: '補假',
      other: '其他',
    },
    methods: {
      admin: '管理員',
      manual: '手動',
      qr: 'QR 碼',
      cardscan: '拍卡',
    },
    categories: {
      student: '學生',
      teacher: '教師',
      staff: '職員',
    },

    qrTitle: '考勤 QR 碼',
    qrAlt: '考勤 QR 碼',
    generating: '產生中…',
    refreshesIn: '更新倒數',
    qrHowTo: '在「我的考勤」按「掃描 QR 碼」去掃此碼。每個碼在出現後 5 分鐘失效。',
    qrGenerated: '已產生的 QR 碼 —— {date}',
    generatedAt: '產生時間',
    generatedBy: '產生者',
    noQrCodes: '此日沒有產生過 QR 碼。',

    permissions: '權限',
    permissionsIntro: '管理員無論此矩陣如何設定，都一定有完整的編輯（新增／修改／刪除）和核實權限。這裡是用來按紀錄類別，將這些權限開放給教師／職員角色。',
    categoryRecords: '{category}紀錄',
    role: '角色',
    edit: '編輯',
    others: '其他人',
    namedInAccessControl: '在「權限管理 → 模組管理員」裡面指定',
    othersNote: '「其他人」可以不論角色，單獨給某幾位職員執行此操作 —— 用來處理上面角色勾選框覆蓋不到的個別例外。',
    othersModalTitle: '其他人 —— {action}{category}紀錄',
    searchStaff: '用姓名或縮寫搜尋職員…',
    noStaffMatch: '沒有符合的職員。',
    done: '完成',
    settingsSaved: '設定已儲存。',
    settingsFailed: '無法儲存設定：{message}',

    addRecordTitle: '新增{category}紀錄',
    editRecordTitle: '編輯{category}紀錄',
    selectClass: '— 請選班別 —',
    selectPerson: '— 請選擇 —',
    classLabel: '班別',
    studentLabel: '學生',
    dateLabel: '日期',
    timeLabel: '時間',
    methodLabel: '方式',
    needPerson: '請選擇一位人士。',
    needDateTime: '請填寫日期同時間。',
    recordSaveFailed: '無法儲存紀錄：{message}',
    deleteRecordConfirm: '確定刪除 {name} 本項考勤紀錄？刪了就沒有得復原。',
    thisPerson: '這位人士',
    deleteRecordFailed: '刪除不到紀錄：{message}',
    verifyFailed: '核實不到紀錄：{message}',
    loadLeaveFailed: '載無法進入請假紀錄：{message}',
    saveLeaveFailed: '無法儲存：{message}',

    manualConfirm: '確定要為現在此一刻新增一項手動考勤紀錄？',
    submitted: '考勤已成功提交。',
    submitFailed: '無法提交考勤：{message}',
    qrNotValid: '此 QR 碼不是有效的考勤碼。',
    qrOtherSchool: '此 QR 碼屬於另一間學校。',
    qrUnverified: '核實不到此 QR 碼。請掃描 QR 分頁上正在顯示的碼。',
    qrCheckFailed: '現在核實不到此 QR 碼。請再試一次。',
    qrExpired: '此 QR 碼已經過期。請掃描 QR 分頁上正在顯示的碼。',

    reject: {
      unreadable: '此不是考勤卡。',
      other_school: '這張卡屬於另一間學校。',
      not_issued: '這位人士未發過卡。請在「卡片」分頁發卡。',
      revoked: '這張卡已經作廢。要重新發卡和重印。',
      expired: '這張卡已經過了有效日期。',
      bad_secret: '這張卡和紀錄不相符 —— 可能是複製品，或已經重新發過卡。',
      already: '已經掃描了。',
    },

    scan: {
      start: '開始掃描',
      stop: '停止掃描',
      loadingRegister: '載入今日名冊中…',
      alreadyOnRegister: '今日名冊已有 {count} 人',
      noVerifyRights: '你沒有核實權限，所以這些掃描會記錄為待核實。',
      cameraFailed: '無法開啟相機。請檢查此網站有沒有相機權限，及有沒有其他分頁佔使用中。',
      cardCheckFailed: '現在檢查不到這張卡。',
      idle: '請將相機對準學生卡上面的 QR 碼。',
      idleOncePerDay: '每人每日只會記錄一次；再掃一次會話你知，不會重複記錄。',
      recorded: '已記錄',
      notRecorded: '未記錄',
      sessionLog: '本次已掃描',
      clearLog: '清除此清單（不會取消任何紀錄）',
      nothingScanned: '未掃描過任何卡。',
    },

    cards: {
      byClass: '按班別列出學生',
      staff: '職員',
      counts: '{active} 張有效 · {expired} 張過期 · {revoked} 張作廢 · {none} 位未發卡',
      expiresOn: '有效期至',
      expiryApplied: '會套用在下面新發的卡。',
      expiryBlank: '留空即張卡一直有效，直至作廢為止。',
      applyToExisting: '套用到現有卡',
      applyToExistingTitle: '修改已存在的卡上面的日期。不需要重印：日期不在印出來的碼裡面。',
      issueMissing: '為 {count} 位未有卡的人發卡',
      building: '產生中…',
      print: '列印 {count} 張',
      reissueAll: '為全部 {count} 人重新發卡',
      revokeActive: '作廢 {count} 張有效卡',
      readOnly: '發卡和作廢是考勤模組管理員的工作。你可以看到發了甚麼，但無法修改。',
      warnExpired: '這裡有 {count} 張卡已經過了有效日期。',
      warnRevoked: '{count} 張已作廢。',
      warnTail: '這些卡在掃描器會被拒絕。過期的可以改上面的日期補救；作廢的要重新發碼，即要重印。',
      nobody: '此清單沒有任何人。',
      expiresLabel: '有效期至 {date}',
      noExpiry: '無有效期限',
      states: {
        active: '● 有效',
        expired: '● 過期',
        revoked: '● 作廢',
        none: '○ 未發卡',
      },
      revokeOneTitle: '作廢 {name} 的卡',
      revokeOneConfirm: '確定作廢 {name} 的卡？印了的卡會立即無法掃描。',
      reissueConfirm: '為此清單全部 {total} 人發一個全新的碼。\n\n其中 {live} 人現在有一張有效卡。那些印了的卡會立即無法掃描，要重印。\n\n繼續？',
      revokeAllConfirm: '作廢 {count} 張有效卡。\n\n那些卡會立即無法掃描。在補發和重印之前，此清單上的人都無法用卡掃描。\n\n繼續？',
      setExpiryConfirm: '將 {count} 張卡的有效期設定為 {date}？\n\n不需要重印 —— 日期不在印出來的碼裡面。',
      clearExpiryConfirm: '移除 {count} 張卡的有效期，令他們一直有效直至作廢？',
      nothingToPrint: '沒有項目可以印 —— 請先發卡。',
      printFailed: '產生不到列印版面：{message}',
      actionFailed: '做不到此操作：{message}',
    },
  },

  substitutionAdmin: {
    loading: '載入代課模組中…',
    tabs: {
      statistics: '統計',
      absence: '缺勤',
      substitution: '代課紀錄',
      arrange: '編排代課',
      settings: '設定',
    },
    importCsv: '匯入 CSV',
    exportCsv: '匯出 CSV',
    logAbsence: '記錄缺勤',
    logExtraDuty: '記錄額外職務',
    selectDate: '選擇日期：',
    saveAll: '全部儲存',
    removeFromList: '從清單移除',

    statsTitle: '統計及可用時段',
    tapHint: '按一堂，再按誰代。用拖拉都得。',
    tapPicked: '已選取 {lesson} —— 在同一欄按一個空堂，或再按一次放回原位。',
    lesson: '課堂',
    avgBalance: '平均結餘：',
    dayCode: '循環日：',
    day: '循環日：',
    notApplicable: '無',
    noCalendarEvent: '此日在校曆找不到對應的日子，所以隱藏了可用時段欄。',
    noCalendarEventArrange: '此日在校曆找不到對應的日子。請檢查學校日曆。',
    noOrphanedLessons: '此日沒有需要代課的堂。（記得要先記錄職員缺勤。）',
    staff: '職員',
    balance: '結餘',
    free: '空堂',
    noStaffData: '找不到職員資料。',
    dropSameColumn: '你必須將堂放在同一節數的欄裡面。',
    saveSubsFailed: '儲存代課時出錯：{message}',
    deleteLessonConfirm: '確定要在此清單刪除 {lesson}？',
    assignmentsSaved: '編排已成功儲存！',
    noSubstitutesAssigned: '未編排任何代課老師。',
    assignFailed: '編排時出錯：{message}',

    logAbsenceTitle: '記錄職員缺勤',
    date: '日期',
    reason: '原因',
    selectStaff: '— 請選職員 —',
    selectReason: '— 請選原因 —',
    deductAmount: '扣減分數',
    remarks: '備註',
    optionalRemarks: '備註（選填）',
    recentAbsences: '近期缺勤',
    last5Days: '最近 5 日',
    currentMonth: '本月',
    allTime: '全部',
    deduction: '扣減',
    action: '操作',
    noAbsences: '找不到缺勤紀錄。',
    staffAndReasonRequired: '必須填寫職員和原因。',
    absenceLogged: '缺勤已成功記錄！',
    absenceFailed: '記錄缺勤時出錯：{message}',
    deleteAbsenceConfirm: '確定要刪除本項缺勤紀錄？',
    absenceNoId: '本項缺勤紀錄沒有 id，所以無法刪除。',
    deleteAbsenceFailed: '刪除缺勤時出錯：{message}',

    logDutyTitle: '記錄額外職務',
    type: '類別',
    reward: '獎勵分數',
    description: '說明',
    dutyPlaceholder: '例如：星期六當值',
    staffRequired: '必須填寫職員。',
    dutyLogged: '額外職務已成功記錄！',
    dutyFailed: '記錄額外職務時出錯：{message}',
    historyTitle: '代課及職務紀錄',
    details: '詳情',
    noSubRecords: '找不到代課或職務紀錄。',
    deleteRecordConfirm: '確定要刪除本項代課／職務紀錄？',
    recordNoId: '本項紀錄沒有 id，所以無法刪除。',
    deleteRecordFailed: '刪除紀錄時出錯：{message}',
    lessonSub: '代課',
    extraDuty: '額外職務',
    substitutedDetail: '在 {room} 代 {class} {subject}（{start}-{end}）',

    initial: '縮寫',
    period: '節數',
    className: '班別',
    subject: '科目',
    room: '課室',
    substitute: '代課老師',
    selectSubstitute: '— 代課老師 —',

    settingsTitle: '代課設定',
    generalSettings: '一般設定',
    defaultReward: '預設代課獎勵分數：',
    recalcTitle: '重新計算職員結餘',
    recalcIntro: '如果你剛剛匯入了 CSV 資料，按此掣可以由歷史紀錄重新計算所有職員的真實累計結餘。',
    recalcConfirm: '確定要由歷史紀錄重新計算所有職員的結餘？可能需要幾秒。',
    recalcDone: '結餘已成功重新計算！',
    recalcFailed: '重新計算結餘時出錯：{message}',
    reasonsTitle: '缺勤原因及扣減',
    defaultDeduction: '預設扣減',
    noReasons: '未設定任何缺勤原因。',
    removeReason: '移除原因',
    dutyTypesTitle: '額外職務類別及獎勵',
    dutyType: '職務類別',
    defaultRewardCol: '預設獎勵',
    noDutyTypes: '未設定任何職務類別。',
    removeDutyType: '移除職務類別',
    settingsSaved: '設定已成功儲存！',
    settingsFailed: '儲存設定時出錯：{message}',

    badDate: '錯誤：有一行的日期格式「{date}」不正確。所有日期必須用 YYYY-MM-DD 格式。',
    importedAbsences: '已匯入 {records} 項缺勤紀錄；調整了 {teachers} 位老師的結餘。',
    importedSubstitutions: '已匯入 {records} 項代課紀錄；調整了 {teachers} 位老師的結餘。',
    unknownInitials: '\n\n找不到對應的職員檔案：{initials}。這些紀錄只儲存了縮寫，所以安全規則保護不到 —— 請先加入這些職員，然後在開發者後台執行「Stamp duty addresses」。',
    importAbsencesFailed: '匯入缺勤時出錯：{message}\n\n結餘可能未調整。再匯入此檔案之前，請先檢查統計分頁 —— 重新匯入帶有 absId 的行是安全的，沒有 absId 就會重複。',
    importSubsFailed: '匯入代課時出錯：{message}\n\n結餘可能未調整。再匯入此檔案之前，請先檢查統計分頁 —— 重新匯入帶有 subId 的行是安全的，沒有 subId 就會重複。',
  },

  invigilation: {
    tabs: {
      invigilation: '監考',
      allocation: '分配',
      schedule: '編排',
      session: '場次',
      statistics: '統計',
      settings: '設定',
    },
    level: '{level} 級',
    importCsv: '匯入場次／編排／分配 CSV',
    exportCsv: '匯出場次／編排／分配 CSV',
    add: '新增',
    saveCount: '儲存（{count}）',
    autoAssign: '自動分配',
    assigning: '分配中…',
    autoAssignTitle: '為所有尚未有監考員的場次自動分配：按縮寫輪流選擇合資格職員，並且避免撞時間。',

    noSessions: '沒有場次。',
    staff: '職員',
    venues: '場地',
    noVenuesAvailable: '沒有可用場地 —— 請在設定裡面設定。',
    assignFailed: '分配監考員失敗：{message}',
    removeFailed: '移除監考員失敗：{message}',
    assignVenueFailed: '分配場地失敗：{message}',
    removeVenueFailed: '移除場地失敗：{message}',

    nothingScheduled: '尚未編排過任何監考。',
    time: '時間',
    subject: '科目',
    className: '班別',
    venue: '場地',
    invigilators: '監考員',
    status: '狀態',
    past: '已過',
    upcoming: '即將',

    setPeriodFirst: '請先在「編排」分頁設定考試期間。',
    setPeriodSettingsFirst: '請先在「設定」分頁設定此評估的考試期間。',
    noClassLevels: '未設定任何級別。',
    saveScheduleFailed: '儲存編排失敗：{message}',
    noEligibleStaff: '未設定任何合資格監考員 —— 請先在「設定」分頁設定。',
    allAssigned: '所有已編排的場次都已經有監考員。',
    autoAssignConfirm: '為 {count} 個尚未有監考員的場次自動分配，並平衡各職員的監考總時數？已經有監考員的場次不會改動。',
    autoAssignDone: '自動分配完成：已分配 {count} 個場次。',
    autoAssignLeftOver: ' 有 {count} 個場次分配不到 —— 該時段沒有足夠合資格的職員有空。',
    autoAssignFailed: '自動分配監考員失敗：{message}',

    paper: '卷別',
    durationMin: '時長（分鐘）',
    scheduled: '已編排',
    actions: '操作',
    noSessionsDefined: '此學年和評估尚未設定任何場次。',
    sessionNeedsFields: '請選擇科目、班別同時長。',
    saveSessionFailed: '儲存場次失敗：{message}',
    deleteSessionConfirm: '刪除此場次？其編排和監考員分配都會一併失去。',
    deleteSessionFailed: '刪除場次失敗：{message}',
    selectSubject: '— 請選科目 —',
    selectClass: '— 請選班別 —',
    noPaper: '— 無 —',
    durationMinutes: '時長（分鐘）',

    invigilator: '監考員',
    totalMin: '合計（分鐘）',
    total: '合計',

    currentAssessment: '目前評估',
    schoolYear: '學年',
    noYears: '未設定學年',
    assessment: '評估',
    noAssessments: '未有評估',
    assessmentPeriods: '評估期間',
    noAssessmentsConfigured: '未設定任何評估 —— 請在系統設定加入。',
    startDate: '開始日期',
    endDate: '結束日期',
    startTime: '開始時間',
    endTime: '結束時間',
    moduleAdmin: '模組管理員',
    role: '角色',
    canEdit: '可編輯',
    others: '其他人',
    namedInAccessControl: '在「權限管理 → 模組管理員」裡面指定',
    invigilatorsTitle: '監考員',
    eligible: '合資格',
    venuesTitle: '場地',
    noLocations: '未設定任何地點 —— 請在系統設定加入。',
    location: '地點',
    available: '可用',
    settingsSaved: '設定已儲存。',
    settingsFailed: '儲存設定失敗：{message}',
    othersModalTitle: '其他人 —— 合資格監考員',
    searchStaff: '搜尋職員…',
    done: '完成',

    exportFailed: '匯出失敗：{message}',
    importDone: '匯入完成：新增 {added} 項，更新 {updated} 項。',
    importDoneSkipped: '匯入完成：新增 {added} 項，更新 {updated} 項，略過 {skipped} 項（缺少科目／班別／時長）。',
    importFailed: '匯入失敗：{message}',
    parseFailed: '解析 CSV 出錯：{message}',
  },

  senInvigilation: {
    importProblems: {
      noStudentId: '這一行沒有學號亦沒有電郵地址',
      notOnRoll: '名冊上沒有人使用該學號或電郵地址',
      duplicateRow: '在此檔案中出現多於一次',
    },
    tabs: {
      rooms: '特別試場',
      register: 'SEN 名冊',
      settings: '設定',
    },
    dragToReorder: '拖拉調次序',
    moveUp: '上移',
    moveDown: '下移',
    afterStart: '開考後',
    beforeEnd: '結束前',
    atTheTime: '指定時間',
    min: '分鐘',
    stepPlaceholder: '監考員要做甚麼',
    removeStep: '移除步驟',
    addStep: '新增步驟',
    notInClockOrder: '並非按時間排 —— 幫我重新排列',
    describe: {
      asItStarts: '一開考',
      afterStart: '開考後 {count} 分鐘',
      atTheEnd: '結束時',
      beforeEnd: '結束前 {count} 分鐘',
      noTimeSet: '未設定時間',
    },

    saveSettings: '儲存設定',
    loadingSittings: '載入試場中…',
    noSittingYet: '暫時未有試場需要特別安排',
    noSittingAdmin: '請先在 SEN 名冊加入學生，再在監考模組編排他們的試卷。兩樣做齊之後，試場就會在這裡出現。',
    noSittingStaff: '此考試在監考模組編排好、而且學生已經在名冊之後，試場就會在這裡出現。',
    specialRoom: '特別試場',
    noSpecialRoom: '尚未有特別試場。',
    venueNotSet: '未設定場地',
    nobodyInRoom: '此試場未安排任何學生。',
    invigilators: '監考員',
    notYetInARoom: '尚未編入試場：',
    editRoom: '編輯試場',
    deleteRoom: '刪除試場',
    saveRoomFailed: '無法儲存此試場：{message}',
    deleteRoomConfirm: '刪除此特別試場{where}？會有 {count} 位學生在這張卷沒有試場。',
    deleteRoomWhere: '（{venue}）',
    deleteRoomFailed: '刪除不到此試場：{message}',

    template: '範本',
    importCsv: '匯入 CSV',
    addStudent: '新增學生',
    searchStudent: '搜尋姓名、學號或班別',
    className: '班別',
    classNumber: '學號',
    name: '姓名',
    accommodations: '特殊安排',
    extraTime: '加時',
    notes: '備註',
    registerEmpty: '名冊尚未有學生。新增一位學生來記錄其考試特殊安排。',
    noStudentMatches: '沒有符合搜尋的學生。',
    inactive: '已停用',
    editEntry: '編輯紀錄',
    removeEntry: '移除紀錄',
    saveEntryFailed: '無法儲存本項紀錄：{message}',
    removeEntryConfirm: '將 {name} 由 SEN 名冊移除？{warning}',
    removeEntryPlaced: ' 它現在在 {count} 個特別試場裡面，那些試場不會受影響。',
    removeEntryFailed: '移除不到本項紀錄：{message}',

    whoCanArrange: '誰可以安排特別試場',
    whoCanArrangeIntro: '管理員和此模組指定的管理員一定可以。無論這裡點勾，名冊本身都只限模組管理員 —— 因為名冊記錄了學生為何有本項特殊安排。',
    defaultRunningOrder: '預設流程',
    defaultRunningOrderIntro: '每個新開的特別試場都會由這張清單開始，之後可以單獨改該試場。在這裡改不會影響已經存在的試場 —— 已經有人核對過的安排不應該在他們不知情下改變。',
    readsAs: '顯示為',
    accommodationTypes: '特殊安排類別',
    accommodationTypesIntro: '本校提供的安排。改名不會影響已經使用中的紀錄，因為紀錄儲存的是代碼；刪走一個之後，舊紀錄就只會顯示該代碼。',
    removeType: '移除類別',
    addType: '新增類別',
    newAccommodation: '新特殊安排',
    saveSettingsFailed: '無法儲存設定：{message}',

    newRoom: '新特別試場',
    editRoomTitle: '編輯特別試場',
    venue: '場地',
    notSet: '未設定',
    extraTimeMin: '加時（分鐘）',
    roomTimes: '{start} 至 {end}',
    roomExtra: '（＋{count} 分鐘）',
    useSuggested: '用 ＋{count} 分鐘 —— 此試場最長的加時',
    studentsPlaced: '學生（已安排 {count} 位）',
    alreadyPlaced: '已安排 {count} 位。',
    nobodyPlacedYet: '尚未安排任何學生。',
    cannotPlaceStudents: '安排學生需要用到 SEN 名冊，而名冊只限此模組的管理員。你可以在這裡設定場地、時間和監考員，之後由掌管名冊的人安排學生。',
    nobodyLeftToPlace: '此試場沒有學生可以再安排。{class} 名冊上的學生已經全部在其他試場。',
    nobodyAssigned: '尚未編排監考員。',
    addInvigilator: '加入監考員…',
    runningOrder: '流程',
    saveRoom: '儲存試場',

    addToRegister: '加一位學生入名冊',
    student: '學生',
    noStudentToAdd: '沒有符合的學生，或符合的都已經在名冊裡面。',
    notesPlaceholder: '監考員需要做的項目，及學校紀錄上的其他資料',
    saveEntry: '儲存紀錄',

    beforeImporting: '匯入之前',
    rowsMatched: '行對應到學生',
    willBeUpdated: '已經在名冊，會被更新',
    rowsSkipped: '行會被略過',
    untouched: '名冊上有 {count} 位學生不在此檔案裡面。他們會完全保持原狀：匯入只會新增和更新，不會清空名冊。已經離校的請用該行的按鈕移除。',
    nothingMatched: '此檔案沒有一行對應到學生。請檢查是否有一欄標題是 SID（或 Email）。按「範本」可以取得此匯入功能讀取的確切欄標題。',
    problems: '問題（{count}）',
    kept: '保留',
    skipped: '略過',
    row: '第 {line} 行',
    whatWillBeWritten: '將會寫入的內容',
    none: '無',
    importing: '匯入中…',
    importCount: '匯入 {count} 位學生',
    readFileFailed: '讀取不到此檔案：{message}',
    importFailed: '完成不到匯入：{message}',
  },

  parentNotice: {
    tabs: {
      outstanding: '待處理',
      notice: '通告',
      payment: '繳費',
      settings: '設定',
    },
    searchAria: '搜尋通告和繳費項目',
    clearSearch: '清除搜尋',
    allSchoolYears: '所有學年',
    allClasses: '所有班別',
    clearFilters: '清除搜尋，顯示所有學年',

    status: {
      draft: '草稿',
      pending_first: '等待第一層審批',
      pending_final: '等待最終審批',
      approved: '已批准',
      rejected: '已退回',
    },

    className: '班別',
    classNumber: '學號',
    sid: '學生編號',
    name: '姓名',
    status_: '狀態',
    action: '操作',
    all: '全部',
    markSigned: '標記為已簽',
    unmark: '取消標記',
    signed: '● 已簽',
    outstandingTag: '● 未簽',
    recordManually: '人手記錄',
    recordManuallyTitle: '只限例外情況 —— 正常情況下 K-Pay 會自己確認繳費',
    remove: '移除',
    paid: '● 已繳',
    unpaid: '● 未繳',

    scopes: {
      school: '全校',
      level: '級別',
      class: '班別',
      student: '學生',
    },
    wholeSchool: '全校',
    everyStudent: '全體學生',
    notOnTheRoll: '不在學生名冊',
    noLongerEnrolled: '{count} 位已離校',
    searchStudents: '搜尋姓名、班別或學生編號…',
    noMatches: '沒有符合的結果。',
    selectAllShown: '全選顯示中的 {count} 位',
    nobodyAdded: '尚未加入任何人。',
    removeRow: '移除 {label}',

    noNoticesIssued: '尚未發出過任何通告。',
    noNoticesYet: '未有通告。',
    notAuthorisedNotice: '你不在可以發出家長通告的職員名單裡面。',
    notAuthorisedPayment: '你不在可以開繳費項目的職員名單裡面。',
    noPaymentsYet: '未有繳費項目。',
    date: '日期',
    datesCoveredOnce: '{count} 個日期 —— 簽一次就涵蓋全部',
    attachment: '附件',
    approveSendsToFamilies: '批准之後會直接發送給家長。',
    approvePassesOn: '批准之後會交去最終審批人。',
    sendBack: '退回',
    approve: '批准',
    sentBackNote: '已退回。尚未發送給任何家長；編輯之後可以重新開始審批。',
    waitingApproval: '等待審批中。尚未發送給任何家長。',
    everyoneSigned: '所有人都簽了本份通告。',
    everyonePaid: '所有人都已經繳費。',
    paymentsByKpay: '繳費由 K-Pay 確認 —— 網上繳付，或在學校終端機拍八達通。',
    issued: '發出日期',
    title: '標題',
    issuer: '發出者',
    targets: '對象',

    settlementConfirm: '為 {name} 記錄一筆 K-Pay 以外的繳費。\n\n正常情況下，無論網上繳付還是在學校拍八達通，K-Pay 都會自己確認。此只限例外情況，請說明原因：',
    removeSettlementConfirm: '移除 {name} 的繳費紀錄？',
    reasonRequired: '必須填寫原因。',
    whyGoingBack: '為何要退回？草擬人會看到此原因。',
    reasonRequiredSendBack: '退回通告時必須填寫原因。',
    editedAfterApproval: '批准後曾修改。',
    savedEditedLive: '已儲存。家長即時見到改動，而今次修改亦已記錄在案。',
    savedSentBack: '已儲存，並由第一層重新開始審批。',
    submittedForApproval: '已提交審批。批核後就會發送給家長。',
    markAllSignedConfirm: '將「{title}」全部 {count} 位未簽學生標記為已簽？',
    deleteNoticeConfirm: '刪除通告「{title}」？連和其簽署紀錄都會一併刪除。',
    deletePaymentConfirm: '刪除「{title}」？連和其繳費紀錄都會一併刪除。',
    createPaymentFailed: '建立繳費項目失敗：{message}',
    updateFailed: '更新失敗：{message}',
    deleteFailed: '刪除失敗：{message}',
    recordFailed: '無法記錄：{message}',
    saveNoticeFailed: '儲存通告失敗：{message}',
    failed: '失敗：{message}',

    whoCanIssue: '誰可以發出通告',
    whoCanIssueIntro: '系統管理員一定可以發出。其他人在「權限管理 → 模組管理員」裡面指定，而該名單就是安全規則唯一會讀的名單。',
    authorisedStaff: '獲授權職員（{count}）',
    onlyAdmins: '無 —— 只有管理員可以發出。',
    referenceOnly: '這裡只是顯示出來參考。分兩個地方編輯會令兩份名單不一致，而安全規則會跟另外一份。',
    maintenance: '維護',
    maintenanceIntro: '通告和繳費項目只有名單上的學生和家長先可以查看。在本條規則生效之前發出的，或對象的家長資料之後有改動的，在重建收件人名單之前不會送到每一個人手上。',
    listsUpToDate: '所有通告和繳費項目的收件人名單都是最新。',
    listsStale: '有 {count} 份文件的收件人名單缺失或過時。',
    repairLists: '重建收件人名單',
    repairing: '重建中…',
    nothingToRepair: '沒有項目需要修復 —— 所有通告和繳費項目的收件人名單都是最新。',
    repairConfirm: '有 {count} 份文件的收件人名單缺失或過時，所以部分收件人看不到。現在重建？',
    repaired: '已重建 {count} 份文件的收件人名單。',
    repairedWithFailures: '已重建 {count} 份，{failed} 份失敗 —— 詳情見主控台。',

    newPayment: '新繳費項目',
    item: '項目',
    itemPlaceholder: '例如：中五旅行費',
    description: '說明',
    amountHkd: '金額（港幣）',
    deadline: '截止日期',
    creating: '建立中…',
    createPayment: '建立繳費項目',

    issueNotice: '發出家長通告',
    editNotice: '編輯家長通告',
    noticeTitle: '標題',
    content: '內容',
    startFromTemplate: '由範本開始：',
    replaceWithTemplate: '用此範本取代現有內容？',
    issuedInNameOf: '以邊位名義發出',
    selectIssuer: '— 請選發出者 —',
    attachmentOptional: '附件（選填）',
    submitForApproval: '提交審批',
  },

  noticeTemplates: {
    title: '通告範本',
    intro: '全校用同一套措辭，令同一個旅行不會因為誰打字而變成兩封不同的信。發通告的人選一個範本之後，',
    introStrong: '仍然可以修改內容',
    introEnd: ' —— 一個不給人改的範本，第一次遇到不正確使就沒有人再用。',
    empty: '尚未有範本。在有至少一個之前，職員每次都要由零開始寫通告。',
    appliesTo: {
      ole: '活動',
      general: '一般',
      both: '任何通告',
    },
    usedForOptions: {
      both: '任何通告',
      ole: '活動通告',
      general: '一般通告',
    },
    print: '列印：{name}',
    printMissing: '已遺失',
    newTemplate: '新增範本',
    templateName: '範本名稱',
    templateNamePlaceholder: '例如：戶外活動家長同意書',
    usedFor: '適用於',
    titleLabel: '標題',
    titlePlaceholder: '例如：{{activityTitle}} —— 回條',
    printable: '可列印版本（選填）',
    none: '無',
    printableHint: '用來印紙本的 Word 文件，在「OLE 管理 → 範本」裡面。措辭在兩邊都有 —— 要自己保持一致；在這裡配對只是記錄哪一份對應哪一份。',
    body: '內文',
    insertPlaceholder: '插入一個佔位符 —— 發出通告時會自動替換：',
    needName: '請為範本改一個名稱。',
    deleteConfirm: '刪除範本「{name}」？已經發出的通告會保留原文。',
    saveFailed: '無法儲存：{message}',
    deleteFailed: '刪除不到：{message}',
    placeholders: {
      schoolName: '學校名稱',
      activityTitle: '活動／通告標題',
      dates: '日期（以逗號分隔）',
      dateCount: '日期數目',
      time: '開始至結束時間',
      venue: '地點',
      replyDueDate: '回條截止日期',
      studentName: '學生姓名（因收件人而異）',
      className: '班別（因收件人而異）',
    },
  },

  noticeApproval: {
    title: '發出前的審批',
    intro: '每份通告都要經過兩個階段 —— 不能關閉。在批核之前它根本沒有任何收件人，所以不會有一段時間令未批的信擺在家長可以查看的地方。',
    stages: {
      firstTitle: '第一層審批人',
      firstHint: '負責該活動的單位 —— 課外活動統籌、科主任，或校務處。',
      finalTitle: '最終審批人',
      finalHint: '校長，或它指派的人。在這裡批准，通告就會送到家長面前。',
    },
    nobodyNamed: '未指定任何人 —— 此階段只有系統管理員可以批核。',
    addPerson: '加入一位…',
    add: '加入',
    saved: '審批設定已儲存。',
    saveFailed: '無法儲存：{message}',
  },

  oleNotices: {
    empty: '尚未有活動通告。可以在活動的「發出通告」按鈕開始一份。',
    recipients: '{count} 位收件人',
    approveSendsToFamilies: '批准之後會直接發送給家長。',
    approvePassesOn: '批准之後會交去最終審批人。',
    sendBack: '退回',
    approve: '批准',
    whyGoingBack: '為何要退回？提出該人會看到此原因。',
    reasonRequired: '退回通告時必須填寫原因。',
    recordFailed: '無法記錄：{message}',
    actions: {
      approve: '已批准',
      reject: '已退回',
      submit: '已提交',
      edit: '已修改',
    },
    stageNames: {
      first: '第一層審批',
      final: '最終審批',
    },
  },

  seatingPlan: {
    tabs: {
      plans: '座位表',
      groups: '群組',
    },
    unknown: '未知',
    everyClassAndGroup: '所有班別和群組',

    plan: '座位表',
    classOrGroup: '班別或群組',
    room: '課室',
    seated: '已入座',
    updated: '更新於',
    noPlanYet: '尚未有座位表',
    noPlanForThat: '此班別或群組沒有座位表',
    listEmptyHint: '選一個班別或群組，然後按「新座位表」。你會先設定課室大細，再安排學生。',
    duplicate: '複製',

    arrangeSeats: '安排座位',
    roomSetup: '課室設定',
    printPlan: '列印這張座位表',
    savePlan: '儲存座位表',
    saved: '已儲存',
    rows: '行數（前到後）',
    columns: '列數（左到右）',
    oneFewer: '減少一個{which}',
    oneMore: '增加一個{which}',
    sizeHint: '打入的數字要離開輸入框或按 Enter 先生效，所以中途經過一個細數字不會清空成間房。',
    clickCell: '按一格去改變它',
    seat: '座位',
    to: '變',
    teacherDesk: '教師枱',
    noSeat: '沒有座位',
    doorHint: '按牆邊可以在該處放門口',
    aisles: '走廊',
    aislesHint: '按兩列之間的幼條，就可以在該處加一條走廊 —— 即常見的兩張枱並排、隔走廊、再兩張枱。行與行之間的幼條做法一樣。',
    desksInPairs: '兩張枱一組',
    noAisles: '沒有走廊',
    blockedHint: '封閉格是另一回事：柱位，或不是四四方方的課室。移除一個座位會先清空它。走廊不會減少任何座位。',
    removeAisle: '移除走廊',
    putAisleHere: '在這裡加走廊',
    aisle: '走廊',
    addAisle: '加走廊',
    putDoorHere: '在這裡放門口',
    door: '門口',
    frontOfRoom: '課室前方',
    teacher: '教師',

    fillEmptySeats: '填滿空位',
    emptyAll: '全部清空',
    nowTapSeat: '現在按一個位安排 {name}。',
    tapHint: '按一位學生，再按一個座位。按已入座的學生可以調位。用滑鼠的話拖拉都得。',
    ghostNotice: '有 {count} 位學生原本坐的格已經不再是座位，所以他們在任何地方都顯示不到。現在已經放回面的名單。記得儲存以保留此修正。',
    shortOfSeats: '學生比座位多了 {count} 位。請在「課室設定」加行或加列。',
    strandedTitle: '已入座但已經不在名單',
    strandedRemove: '{name} —— 移除',
    notSeated: '未入座（{count}）',
    nobodyInIt: '此班別或群組沒有任何學生。',
    everybodySeated: '所有人都有座位。',

    leaveWithoutSaving: '未儲存就離開？這張座位表的改動會失去。',
    deletePlanConfirm: '刪除「{name}」？已安排的 {count} 位學生座位會失去。',
    smallerRoomConfirm: '縮細課室會令 {count} 位已入座的學生離開座位。繼續？',
    autoLeftOver: '已安排 {placed} 位。尚有 {left} 位沒有位坐 —— 此間房需要更多座位。',
    clearSeatsConfirm: '清空所有座位？{count} 位學生會回到未入座名單。',
    createFailed: '建立不到這張座位表：{message}',
    saveFailed: '無法儲存這張座位表：{message}',
    deleteFailed: '刪除不到這張座位表：{message}',
    duplicateFailed: '無法複製這張座位表：{message}',

    newPlan: '新座位表',
    newPlanButton: '新座位表',
    newPlanButton: '新座位表',
    newPlanButton: '新座位表',
    newPlanButton: '新座位表',
    choose: '請選擇…',
    nameLabel: '名稱',
    nameHint: '留空就會用班別或群組的名',
    roomSize: '課室大細',
    creating: '建立中…',
    createAndArrange: '建立並安排座位',

    groupsIntro: '群組是一份有名的學生名單，會出現在同班別一樣的下拉選單裡面。',
    groupsWhy: '用來處理不是成班上的堂 —— 選修科、分組、補底班。',
    group: '群組',
    drawnFrom: '來自',
    students: '學生',
    plans: '座位表',
    noGroupYet: '尚未有群組',
    noGroupHint: '按「新群組」，改名，再選擇學生。建立座位表時就會見到它。',
    newGroup: '新群組',
    editGroup: '編輯群組',
    groupName: '群組名稱',
    groupNamePlaceholder: '3A/3B 物理、中四數學第 2 組…',
    pickFrom: '選擇選範圍',
    everyClass: '所有班別',
    search: '搜尋',
    searchPlaceholder: '姓名或學生編號',
    nobodyMatches: '沒有符合的學生。',
    othersChosen: '有部分已選擇的學生屬於其他班別。他們仍然留在群組裡面；改變篩選就會見到他們。',
    saveGroup: '儲存群組',
    saveGroupFailed: '無法儲存此群組：{message}',
    deleteGroupConfirm: '刪除群組「{name}」？{warning}',
    deleteGroupUsed: ' 由它建立的 {count} 張座位表會失去名單，不過已經排好的座位會保留。',
    deleteGroupFailed: '刪除不到此群組：{message}',
  },

  studentCredit: {
    importProblems: {
      noStudentId: '這一行沒有學號亦沒有電郵地址',
      notOnRoll: '名冊上面沒有人使用中該學號或電郵地址',
      noItem: '沒有寫明是哪一個獎懲項目',
      unknownItem: '「{item}」不在本校的獎懲項目清單裡面',
      badDate: '無法讀取日期「{date}」',
      badPoints: '無法讀取分數「{points}」 — 改用了項目本身的分數',
    },
    tabs: {
      statistics: '統計',
      record: '紀錄',
      settings: '設定',
    },
    nature: {
      award: '獎勵',
      punishment: '懲處',
    },
    unknown: '未知',

    templateTitle: '下載空白 CSV 範本',
    exportTitle: '匯出顯示中的紀錄',
    importTitle: '由 CSV 匯入紀錄',
    className: '班別',
    student: '學生',
    allStudents: '所有學生',
    natureLabel: '類別',
    all: '全部',
    noYears: '未設定學年',

    netBalanceStats: '淨結餘統計',
    lifetimeSuffix: '（累計）',
    yearSuffix: '（{year}）',
    byClassLevel: '按級別',
    byClass: '按班別',
    level: '級別',
    students: '學生（{count}）',
    studentsCol: '學生',
    netBalance: '淨結餘',
    noData: '沒有資料。',
    highestFirst: '由高到低',
    lowestFirst: '由低到高',
    no: '學號',
    engName: '英文姓名',
    cName: '中文姓名',
    noStudentsFound: '找不到學生。',
    lifetime: '累計',
    currentBalance: '目前結餘（{scope}）',

    date: '日期',
    item: '項目',
    balance: '分數',
    remarks: '備註',
    staff: '負責職員',
    actions: '操作',
    noRecordsThisYear: '此學年沒有任何紀錄。',
    noRecordsMatch: '沒有紀錄符合目前的篩選。',

    addRecord: '新增紀錄',
    editRecord: '編輯紀錄',
    selectClass: '— 請選班別 —',
    currentBalanceLine: '目前結餘（{scope}）：',
    staffInCharge: '負責職員',
    remarksOptional: '備註（選填）',
    needStudent: '請選擇一位學生。',
    needItem: '請選擇一個獎懲項目。',
    needYear: '請先選擇學年。',
    saveRecordFailed: '儲存紀錄失敗：{message}',
    deleteRecordConfirm: '刪除 {name} 本項{nature}紀錄？刪了就沒有得復原。',
    deleteRecordFailed: '刪除紀錄失敗：{message}',

    saveSettings: '儲存設定',
    settingsSaved: '設定已儲存。',
    settingsFailed: '儲存設定失敗：{message}',
    balanceMode: '結餘計算方式',
    resetEachYear: '每個學年重新計算',
    lifetimeRunningTotal: '累計總分',
    itemsTitle: '獎懲項目（{count}）',
    importCsv: '匯入 CSV',
    exportCsv: '匯出 CSV',
    itemCode: '代碼',
    description: '說明',
    noItems: '尚未有項目。',
    codePlaceholder: '例如：LATE01',
    descriptionPlaceholder: '例如：遲到',
    duplicateIds: '項目代碼重複：{ids}。每個項目都要有唯一的代碼。',
    noDataRows: 'CSV 檔案沒有任何資料行。',
    itemsImported: '匯入完成：新增 {added} 項，更新 {updated} 項。按「儲存設定」先會寫入。',
    itemsImportedSkipped: '匯入完成：新增 {added} 項，更新 {updated} 項，略過 {skipped} 項（缺少代碼）。按「儲存設定」先會寫入。',
    itemsImportFailed: '匯入 CSV 失敗：{message}',
    recalcTitle: '重新計算結餘',
    recalcIntro: '由所有歷史紀錄重新計算每位學生的結餘。如果發現結餘不正確，可以用此功能。',
    recalcNow: '立即重新計算',
    recalculating: '重新計算中…',
    recalcConfirm: '由所有歷史紀錄重新計算全部學生結餘？可能需要幾秒。',
    recalcDone: '結餘已成功重新計算。',
    recalcFailed: '重新計算結餘失敗：{message}',

    chooseYearFirst: '請先選擇學年 —— 匯入的紀錄會歸入該學年。',
    readFileFailed: '讀取不到此檔案：{message}',
    importFailed: '完成不到匯入：{message}',
    beforeImporting: '匯入之前',
    recordsToAdd: '項紀錄會新增',
    netPoints: '淨分數',
    rowsSkipped: '行會被略過',
    importAdds: '匯入是將這些當作新紀錄加入 —— 不會取代已經存在的項目。同一個檔案匯入兩次，所有紀錄就會出現兩次。之後結餘會由全部紀錄重新計算，所以總數兩邊都會正確。',
    importAddsStrong: '加入',
    nothingUsable: '此檔案沒有任何可以用的內容。請檢查是否有學生編號欄和項目代碼欄 —— 按「範本」可以取得此匯入功能讀取的確切欄標題。',
    problems: '問題（{count}）',
    kept: '保留',
    skipped: '略過',
    row: '第 {line} 行',
    whatWillBeAdded: '將會新增的內容',
    points: '分數',
    importing: '匯入中…',
    addRecords: '新增 {count} 項紀錄',
  },

  patrolDuty: {
    tabs: {
      patrol: '巡邏',
      allocation: '分配',
      preference: '意向',
      statistics: '統計',
      settings: '設定',
    },
    staff: '職員',
    noEligibleStaffPanel: '沒有合資格職員 —— 請在設定裡面設定。',

    importPrefs: '匯入意向 CSV',
    exportPrefs: '匯出意向 CSV',
    autoAssignTitle: '為所有空缺時段自動編排巡邏職員，平衡工作量並盡量顧及意向',
    autoAssign: '自動分配',
    assigning: '分配中…',

    date: '日期',
    session: '時段',
    noSessionsConfigured: '未設定任何巡邏時段。',
    noPatrolDays: '此月沒有巡邏日。',
    total: '合計',

    readOnlyPrefs: '只有管理員和獲派職員可以修改意向。這是唯讀檢視。',
    noEligibleStaff: '尚未設定任何合資格職員。',
    noProfile: '找不到 {initial} 的職員檔案，所以沒有帳戶可以儲存本項設定。請先在「職員帳戶」加入其電郵。',
    prefFailed: '更新意向失敗：{message}',

    assignFailed: '編排職員失敗：{message}',
    removeFailed: '移除職員失敗：{message}',
    noEligibleForAuto: '未設定任何合資格巡邏職員 —— 請先在「設定」分頁設定。',
    noSessionsForAuto: '未設定任何巡邏時段 —— 請先在「設定」分頁設定。',
    noDaysForAuto: '此學年尚未設定任何巡邏日。',
    allSlotsFilled: '所有巡邏時段都已經有職員。',
    autoAssignConfirm: '為 {count} 個空缺時段自動編排巡邏職員，平衡總工作量並盡量顧及意向？已經有職員的時段不會改動。',
    autoAssignFailed: '自動分配失敗：{message}',

    exportFailed: '匯出失敗：{message}',
    importDone: '匯入完成：更新了 {updated} 項。',
    importDoneSkipped: '匯入完成：更新了 {updated} 項，略過 {skipped} 項（不認得的職員縮寫）。',
    importFailed: '匯入失敗：{message}',
    parseFailed: '解析 CSV 出錯：{message}',

    readOnlySettings: '只有管理員和獲派職員可以修改這些設定。這是唯讀檢視。',
    settingsFailed: '儲存設定失敗：{message}',
    patrolYear: '巡邏學年',
    noYears: '未設定學年',
    patrolSessions: '巡邏時段',
    noSessionsYet: '尚未設定任何時段。',
    label: '名稱',
    startTime: '開始時間',
    endTime: '結束時間',
    equivalentLoad: '相等工作量',
    patrolDays: '巡邏日',
    extraDays: '額外巡邏日（非上課日但仍然需要巡邏）',
    add: '新增',
    none: '無',
    excludedDays: '豁免上課日（上課日但不需要巡邏）',
    exclude: '豁免',
    moduleAdmin: '模組管理員',
    role: '角色',
    canEdit: '可編輯',
    others: '其他人',
    namedInAccessControl: '在「權限管理 → 模組管理員」裡面指定',
    patrolEligibility: '巡邏資格',
    needsPatrol: '需要巡邏',
    othersInclude: '其他人（納入）',
    othersExclude: '其他人（豁免）',
    includeModalTitle: '其他人 —— 納入巡邏',
    excludeModalTitle: '其他人 —— 豁免巡邏',
    searchStaff: '搜尋職員…',
    done: '完成',
  },

  systemSettings: {
    logoTooBig: '該檔案有 {size} MB。校徽必須小於 2 MB。',
    tabs: {
      dashboard: '主頁',
      parameters: '系統參數',
      modules: '模組權限',
    },
    categories: {
      hr: '用戶角色及人事',
      campus: '校舍及設施',
      inventory: '物資',
      adminGroup: '行政組別',
      academic: '學務',
    },
    lists: {
      edbRanks: '教育局職級',
      jobRoles: '職務類別',
      locations: '地點及課室',
      floors: '樓層',
      campusStatus: '校舍管理狀態',
      sourceOfFunding: '經費來源',
      inventoryCategory: '物資類別',
      inventoryCommittee: '委員會',
      departments: '部門',
      classLevels: '級別',
      classes: '班別',
      subjects: '開設科目',
      assessments: '評估',
    },

    toggleModules: '開關模組',
    moduleCategories: {
      user: '個人事務',
      admin: '資產管理',
      school_admin: '學校行政',
      student_affairs: '學生事務',
      duties: '職務安排',
      system: '系統模組',
    },
    required: '必需',

    exportCsv: '匯出 CSV',
    importCsvMerge: '匯入 CSV（與現有資料合併）',
    seq: '排序',
    code: '代碼',
    codeRequired: '代碼（必填）',
    nameEn: '英文名稱',
    nameEnRequired: '英文名稱（必填）',
    nameZh: '中文名稱',
    samsCode: 'SAMS_Code',
    samsCodeCol: 'SAMS 代碼',
    department: '部門',
    departmentNone: '部門（無）',
    moi: '授課語言',
    writtenTest: '筆試',
    bldg: '大樓',
    selectFloor: '請選樓層',
    floor: '樓層',
    capacity: '容量',
    status: '狀態',
    selectLevel: '請選級別',
    level: '級別',
    subGroup: '分組',
    active: '啟用',
    action: '操作',
    noParameters: '未設定任何參數。',
    editItem: '編輯項目',
    deleteItem: '刪除項目',
    codeExists: '此代碼已經有項目使使用中。',
    codeAndNameRequired: '代碼和英文名稱是必填。',
    saveError: '儲存出錯：{message}',
    savingError: '儲存出錯：{message}',
    importSuccess: '{list} 匯入成功。',
    importFailed: '匯入項目失敗。詳情見主控台。',
    parseFailed: '解析 CSV 出錯：{message}',

    basicTitle: '學校基本及主頁設定',
    uploading: '上載中…',
    replaceLogo: '更換校徽',
    uploadLogo: '上載校徽',
    remove: '移除',
    logoUrlPlaceholder: 'https://example.com/logo.png',
    logoHint: 'PNG、JPG、SVG 或 WebP，2 MB 以內。會顯示在側邊欄、登入頁，以及有人將本平台加到主畫面時的應用程式圖示。記得按儲存。',
    notAnImage: '此不是圖片。請用 PNG、JPG 或 SVG。',
    uploadFailed: '上載失敗：{message}',
    uploadRefused: '儲存空間拒絕了今次上載。可能是此帳戶沒有權更改校徽、學校已停用，或儲存空間用盡 —— 詳情在主控台的錯誤訊息。',
    tagline: '標語／歡迎訊息',
    taglinePlaceholder: '培育學生，迎向未來',
    taglineHint: '會顯示在登入畫面。',
    searchAddress: '搜尋地址（例如：屯門鄉城中學）',
    searching: '搜尋中…',
    findCoordinates: '搜尋座標',
    latitude: '緯度',
    longitude: '經度',
    displayName: '顯示名稱（天氣資訊）',
    displayNamePlaceholder: '例如：香港',
    weatherHint: '此名稱和座標會用來在主頁顯示當地天氣資訊。',
    saveSchoolSettings: '儲存學校設定',
    locationNotFound: '找不到此地點。請換一個搜尋字詞。',
    locationSearchError: '搜尋地點時出錯。',
    brandingSaved: '品牌設定已更新！介面會即時重新整理。',
    brandingFailed: '更新品牌設定出錯：{message}',

    calendarUrlPlaceholder: 'https://calendar.google.com/calendar/embed?src=...',
    calendarHint: '選填。主頁會用本平台自己的紀錄砌一個日曆 —— 活動、代課、監考、場地預約 —— 所以只有學校放在平台以外的項目先需要用嵌入日曆。',
    hideEmbed: '在主頁隱藏嵌入日曆',
    hideEmbedHint: '上面的網址會保留，所以之後可以直接重新開啟，不需要重新貼一次。',
    nothingToHide: '沒有項目可以隱藏 —— 未設定嵌入網址。',
    saveSettings: '儲存設定',
    dashboardSaved: '主頁設定已更新！',
    dashboardFailed: '更新主頁設定出錯：{message}',
  },

  accessControl: {
    loading: '載入系統群組中…',
    tabs: {
      staff: '職員模組',
      family: '學生及家長模組',
      byPerson: '按人檢視',
      moduleAdmins: '模組管理員',
    },
    module: '模組',
    roles: {
      teacher: '教師',
      staff: '非教學職員',
      student: '學生',
      parent: '家長',
    },
    on: '開啟',
    off: '關閉',
    exception: '個別例外',
    noFamilyExceptions: '家長端不支援個別例外 —— 此設定等和關閉。請設為開啟或關閉。',
    searchStaff: '搜尋職員…',
    noMatches: '沒有符合的結果。',
    pickSomebody: '選一個人，就會見到該人可以開啟哪些模組。',
    isAdmin: '此帳戶是系統管理員，所有模組都可以開啟。如果不希望如此，請在「職員帳戶」修改該帳戶的角色。',
    noRole: '此帳戶沒有可用的角色，所以甚麼都無法開啟。請在「職員帳戶」設定一個。',
    exceptionHint: '在這裡勾一個，就是將此電郵加入該模組的例外名單。如果想收回某人一個角色層面已開啟的模組，要先在「職員模組」將該角色關閉，再在這裡單獨重新開啟給需要的人。',
    byPersonTitle: '一個人可以開啟哪些模組',
    byPersonIntro: '和「職員模組」是同一套設定，只是改成一次查看一個人。改動用同一個儲存掣儲存。',
    moduleAdminsTitle: '模組管理員',
    moduleAdminsIntro: '角色決定一個人看到甚麼。委任一位職員做某個模組的管理員，該人就可以自行管理該模組的設定，不需要聯絡系統管理員。至於「通告及繳費」和「薪酬審核」，此身份還會一併帶有該兩個模組本身保留的紀錄權限 —— 發出通告，及查閱薪酬數字。',
    moduleAdminsWhoCanEdit: '只有系統管理員可以修改此一頁。如果模組管理員可以修改，該人就可以將自己加入其他所有模組。',
    noModuleAdmin: '未有模組管理員 —— 只有系統管理員可以更改此模組。',
    removePerson: '移除 {email}',
    accessSaved: '模組權限已更新。',
    accessFailed: '儲存模組權限失敗。',
    adminsSaved: '模組管理員已更新。',
    adminsFailed: '儲存失敗：{message}',
  },

  roles: {
    developer: '開發者',
    system_admin: '系統管理員',
    teacher: '教師',
    non_teaching: '非教學職員',
    student: '學生',
    parent: '家長',
    denied: '無權限',
  },

  staffMgt: {
    loading: '載入用戶目錄中…',
    tabs: {
      all: '全體職員',
      admins: '管理員',
      teachers: '教師',
      supporting: '支援職員',
    },
    search: '搜尋姓名或電郵…',
    filter: '篩選…',
    exportCsv: '匯出 CSV',
    importCsv: '匯入 CSV',

    name: '姓名',
    email: '電郵',
    role: '角色',
    jobRole: '職務類別',
    rank: '職級',
    edbRank: '教育局職級',
    gender: '性別',
    initial: '縮寫',
    actions: '操作',
    noUsers: '沒有符合條件的用戶。',
    loginEnabled: '已啟用登入',
    editUser: '編輯用戶',
    deleteUser: '刪除用戶',
    batchMigrating: '批次權限表格正在遷移中。',

    editAccount: '編輯系統帳戶',
    addAccount: '新增系統帳戶',
    emailLabel: '電郵／登入名稱',
    emailPlaceholder: 'user@example.com',
    emailFixed: '電郵不改得。',
    enableLogin: '啟用登入權限',
    password: '密碼',
    passwordOverride: '（輸入即覆寫）',
    passwordKeep: '留空即保留原有密碼',
    passwordForcesChange: '這樣會強制用戶下次登入時更改密碼。',
    lastName: '姓',
    lastNamePlaceholder: '例如：陳',
    firstName: '名',
    firstNamePlaceholder: '例如：大文',
    chineseName: '中文姓名（選填）',
    chineseNamePlaceholder: '例如：陳大文',
    accessLevel: '系統權限級別',
    genders: { male: '男', female: '女' },
    staffInitial: '職員縮寫／編號',
    staffInitialPlaceholder: '例如：JDO',
    selectJobRole: '請選職務類別',
    selectRank: '請選職級',
    saveChanges: '儲存變更',
    createAccount: '建立系統帳戶',

    invalidRole: '角色不正確',
    invalidGender: '性別不正確',
    invalidJobRole: '已選一個不正確的職務類別。',
    invalidRank: '已選一個不正確的職級。',
    passwordRequired: '新檔案要啟用登入權限，就必須設定密碼。',
    passwordTooShort: '密碼最少要 6 個字元。',
    saveFailed: '儲存用戶出錯：{message}',
    deleteConfirm: '確定要完全移除 {email}？',
    deleteFailed: '刪除用戶出錯：{message}',
    deleteManyConfirm: '確定要完全移除 {count} 位用戶？',
    deleteManyFailed: '刪除用戶出錯：{message}',
    resetSent: '重設密碼電郵已寄去 {email}',
    resetFailed: '寄重設密碼電郵出錯：{message}',

    validationFailed: '驗證失敗，匯入已中止。',
    andMoreErrors: '…尚有 {count} 個錯誤。',
    rowInvalidRole: '第 {row} 行（{email}）：角色「{value}」不正確。必須是以下其中一個：{allowed}。',
    rowInvalidGender: '第 {row} 行（{email}）：性別「{value}」不正確。',
    rowInvalidJobRole: '第 {row} 行（{email}）：職務類別「{value}」不正確。',
    rowInvalidRank: '第 {row} 行（{email}）：職級「{value}」不正確。',
    imported: '已成功匯入／更新 {count} 位用戶。',
    importFailed: '匯入 CSV 出錯：{message}',
    parseFailed: '解析 CSV 出錯：{message}',
  },

  studentMgt: {
    tab: '學生',
    search: '搜尋學生…',
    allClasses: '所有班別',
    exportCsv: '匯出 CSV',
    importCsv: '匯入 CSV',
    filter: '篩選…',
    all: '全部',

    sid: '學生編號',
    className: '班別',
    classNo: '學號',
    name: '姓名',
    chineseName: '中文姓名',
    email: '電郵',
    gender: '性別',
    dob: '出生日期',
    actions: '操作',
    unassigned: '未編班',
    loginEnabled: '已啟用登入',
    noProfiles: '找不到任何檔案。',
    genders: { male: '男', female: '女' },

    editProfile: '編輯檔案',
    addProfile: '新增檔案',
    emailLabel: '電郵地址（主鍵）',
    emailPlaceholder: 'user@example.com',
    emailSynced: '電郵由帳戶管理同步過來，不改得。',
    guardianSection: '家長／監護人',
    guardianEmail: '監護人電郵',
    guardianEmailHint: '用來簽家長通告',
    guardianPasswordHint: '留空即保留原有密碼',
    guardianEmail2: '第二位監護人電郵',
    optional: '選填',
    mainContact: '主要聯絡人',
    firstGuardian: '第一位監護人',
    secondGuardian: '第二位監護人',
    guardianHint: '設定密碼即為該位監護人建立（或重設）該位監護人自己的登入。留空密碼就只記錄該電郵地址，暫時不開帳戶。兩位監護人都可以查閱學生紀錄和簽通告 —— 由誰簽署就會記錄在回條上。主要聯絡人是學校首先聯絡的人，並不限制誰可以簽署。',
    enableLogin: '啟用登入權限',
    password: '密碼',
    passwordForcesChange: '這樣會強制用戶下次登入時更改密碼。',
    lastName: '姓',
    firstName: '名',
    studentId: '學生編號（SID）',
    currentClass: '現時班別',
    selectClass: '請選班別',
    classNumber: '學號',
    saveProfile: '儲存檔案',

    batchHint: '欄位留空，該欄就會保留所有已選學生的原有值。',
    leaveBlankToSkip: '留空即跳過',
    applyBatch: '套用批次更新',
    batchNeedsField: '請最少指定一個要更新的欄位。',
    batchFailed: '更新出錯：{message}',

    emailRequired: '必須填寫電郵。',
    emailInUse: '此電郵地址已經有人使用中。',
    sidRequired: '必須填寫學生編號（SID）。',
    sidInUse: '此學生編號（SID）已經有人使用中。',
    classNumberPositive: '學號必須是正整數。',
    invalidGender: '性別不正確',
    passwordRequired: '新檔案要啟用登入權限，就必須設定密碼。',
    passwordTooShort: '密碼最少要 6 個字元。',
    guardiansSame: '兩位監護人的電郵地址相同。請只用一個，或為第二位監護人另外提供一個地址。',
    guardianLoginFailed: '建立不到 {email} 的監護人登入：{message}',
    saveFailed: '儲存出錯：{message}',
    deleteConfirm: '確定要刪除 {id} 的檔案資料？',
    deleteFailed: '刪除出錯：{message}',
    deleteManyConfirm: '確定要刪除 {count} 位學生？',

    validationFailed: '驗證失敗，匯入已中止。',
    andMoreErrors: '…尚有 {count} 個錯誤。',
    rowInvalidGender: '第 {row} 行（{email}）：性別「{value}」不正確。',
    imported: '已成功匯入／更新 {count} 份學生檔案。',
    importFailed: '匯入學生 CSV 出錯：{message}',
    parseFailed: '解析 CSV 出錯：{message}',
  },

  calendarAdmin: {
    setCurrentYearConfirm: '確定要將 {year} 設定為本學年？',
    deleteYearConfirm: '確定要永久刪除學年 {year}？此動作會刪除該學年所有校曆項目。',
    tabs: {
      calendar: '日曆',
      allEvents: '所有項目',
      settings: '設定',
    },
    noYears: '未設定學年',
    academicYear: '學年',
    setCurrent: '設為目前學年',
    clear: '清除',
    locked: '已鎖定 —— 按一下解鎖以允許編輯',
    unlocked: '未鎖定 —— 按一下鎖定並凍結日曆',
    importCsv: '由 CSV 匯入日曆',
    exportCsv: '將日曆匯出做 CSV',
    swapDays: '對調循環日',
    assignCycles: '為全學年編排循環日',
    deleteYear: '刪除此學年',
    addYear: '新增學年',
    pickYear: '請選擇或建立一個學年。',
    weekdays: { sun: '日', mon: '一', tue: '二', wed: '三', thu: '四', fri: '五', sat: '六' },
    customProfile: '自訂',
    defaultProfile: '預設時間表',

    prep: '預備',

    initTitle: '建立新學年',
    yearName: '學年名稱',
    yearNamePlaceholder: '例如：2025-2026',
    startDate: '開始日期',
    endDate: '結束日期',
    generateYear: '產生學年',
    generateFailed: '產生學年出錯：{message}',

    assignTitle: '編排循環日',
    cycleType: '循環方式',
    continuous: '連續（Day A、Day B…）',
    fixedWeek: '固定週（一、二…）',
    cycleLength: '循環長度（日數）',
    skipPrep: '跳過開頭的預備日',
    skipPrepHint: 'Day A 開始之前的日數。',
    executeAssignment: '執行編排',
    assignFailed: '編排循環日出錯：{message}',

    editDay: '編輯日曆日子',
    editDays: '編輯日曆（{count} 日）',
    multipleDates: '已選擇多個日期',
    dayType: '日子類型',
    multiValue: '多個值（維持不變）',
    cycleOverride: '循環日覆寫',
    timetableProfile: '時間表設定',
    descriptionLabel: '說明／活動名稱',
    saveChanges: '儲存變更',
    updateFailed: '更新日子出錯：{message}',

    swapIntro: '將兩個指定日期的循環屬性（Day A、時間表等）對調。',
    firstDate: '第一個日期',
    secondDate: '第二個日期',
    executeSwap: '執行對調',
    swapNotFound: '在目前學年找不到此兩個日期。',
    swapFailed: '對調日子出錯：{message}',

    lockFailed: '更新鎖定狀態出錯：{message}',
    setCurrentFailed: '設定目前學年出錯：{message}',
    cannotDeleteLocked: '不可以刪除已鎖定的學年。',
    deleteYearFailed: '刪除學年出錯：{message}',
    cannotImportLocked: '不可以匯入去已鎖定的學年。',
    invalidCsv: 'CSV 無效或沒有內容。',
    imported: '已由 CSV 成功更新 {count} 日。',
    noMatchingDates: '找不到可以更新的對應日期。',
    importFailed: '匯入 CSV 出錯：{message}',
  },

  timetableAdmin: {
    loading: '載入時間表設定中…',
    tabs: {
      timetables: '時間表',
      settings: '設定',
    },
    importCsv: '由 CSV 匯入時間表設定',
    exportCsv: '將時間表設定匯出做 CSV',
    createProfile: '建立時間表設定',
    empty: '未有任何時間表設定。建立一個就可以開始。',
    defaultTimetable: '預設時間表',

    editProfile: '編輯設定',
    newProfile: '新增設定',
    profileName: '設定名稱',
    profileNamePlaceholder: '例如：正常時間表',
    shortCode: '簡碼',
    shortCodePlaceholder: '例如：NORM',
    dailyPeriods: '每日節數',
    periodName: '節數名稱',
    type: '類型',
    moveUp: '上移',
    moveDown: '下移',
    deletePeriod: '刪除節數',

    saveFailed: '儲存設定出錯：{message}',
    deleteConfirm: '確定要刪除此時間表設定？',
    deleteFailed: '刪除設定出錯：{message}',
    invalidCsv: 'CSV 無效或沒有內容。',
    imported: 'CSV 匯入成功：更新 {updated} 項，新增 {created} 項。',
    importFailed: '匯入 CSV 出錯：{message}',
  },

  lessonAllocation: {
    tab: '教師時間表',
    noYear: '未有學年',
    defaultSuffix: '（預設）',
    importCsv: '匯入 CSV',
    exportCsv: '匯出 CSV',
    saveTimetable: '儲存時間表',
    period: '節數',
    chooseTeacher: '— 請選教師 —',
    className: '班別',
    subject: '科目',
    room: '課室',
    pickTeacher: '請選擇一位教師以檢視和編排課堂。',
    saved: '時間表已成功儲存！',
    saveFailed: '儲存時間表出錯：{message}',
    pickYearToExport: '請先選擇要匯出的學年。',
    exportFailed: '匯出 CSV 出錯：{message}',
    parseFailed: '解析 CSV 檔案出錯',
    emptyCsv: 'CSV 檔案沒有內容',
    imported: '已成功匯入 {count} 節課堂。',
    importFailed: '匯入資料出錯：{message}',
  },

  inventoryAdmin: {
    tabs: {
      master: '物資總表',
      applications: '申請及盤點',
      settings: '設定',
    },
    exportCsv: '匯出 CSV',
    importCsv: '匯入 CSV',

    itemId: '物品編號',
    itemName: '物品名稱',
    category: '類別',
    unitCost: '單價',
    unitCostForm: '單價（$）',
    assignedTo: '編配給',
    location: '地點',
    fundingSource: '經費來源',
    funding: '經費',
    committee: '委員會',
    status: '狀態',
    costTotal: '總值',
    actions: '操作',
    noInventory: '未有任何物資紀錄。',

    editItem: '編輯物資',
    registerItem: '登記新物資',
    itemIdOptional: '物品編號（選填）',
    itemIdPlaceholder: '留空會自動產生編號',
    itemNamePlaceholder: '例如：科學實驗室顯微鏡',
    qty: '數量',
    totalCost: '總值',
    saveItem: '儲存物資',
    needsReviewShort: '需要覆核',

    type: '類別',
    item: '物品',
    user: '申請人',
    remarks: '備註',
    noApplications: '找不到任何申請。',
    approve: '批准',
    reject: '拒絕',
    appStatuses: {
      pending: '待處理',
      approved: '已批准',
      rejected: '已拒絕',
    },
    appTypes: {
      reportdiscrepancy: '申報差異',
      writeoff: '註銷',
      replacement: '更換',
    },

    saveFailed: '儲存物資出錯：{message}',
    deleteConfirm: '刪除本項物資紀錄？',
    error: '錯誤：{message}',
    imported: '匯入完成。成功 {ok} 項，失敗 {failed} 項。',
    parseFailed: '解析 CSV 出錯：{message}',
  },

  mdmAdmin: {
    tabs: {
      inventory: '資產管理',
      approvals: '預約審批',
      settings: '設定',
    },
    exportCsv: '匯出 CSV',
    importCsv: '匯入 CSV',

    assetId: '資產編號',
    assetName: '資產名稱',
    type: '類型',
    qty: '數量',
    quantity: '數量',
    status: '狀態',
    rules: '規則',
    actions: '操作',
    noAssets: '資產清單暫時沒有項目。',
    available: '可借',
    fullyBooked: '已全部借出',
    autoApprove: '自動批准',
    requiresReview: '需要審批',
    forceReturn: '強制歸還',

    editAsset: '編輯 IT 資產／帳戶',
    registerAsset: '登記新 IT 資產／帳戶',
    assetIdOptional: '資產編號（選填）',
    autoGenerate: '自動產生',
    nameOrId: '名稱／識別碼',
    fromInventory: '由 IT 物資清單選擇',
    customItem: '自訂項目',
    namePlaceholder: '例如：iPad Pro #04',
    hardwareDevice: '硬件裝置',
    digitalAccount: '數碼帳戶',
    approvalType: '審批方式',
    requiresAdminApproval: '需要管理員批准',
    autoApproveWhenAvailable: '有貨時自動批准',
    saveAsset: '儲存資產',

    assetRequested: '申請的資產',
    user: '申請人',
    timeSlot: '時段',
    noBookings: '找不到任何預約。',
    requested: '申請於：',
    unknown: '未知',
    to: '至',
    approve: '批准',
    reject: '拒絕',
    markReturned: '標記為已歸還',

    quantityExceeds: '加不到資產：數量（{wanted}）超出可用存貨（{available}）。',
    addFailed: '新增資產出錯：{message}',
    imported: '匯入完成。成功 {ok} 項，失敗 {failed} 項。',
    parseFailed: '解析 CSV 出錯：{message}',
    deleteConfirm: '刪除本項資產？',
    deleteFailed: '刪除出錯：{message}',
    error: '錯誤：{message}',
    forceReturnConfirm: '強制將所有進行中的預約標記為已歸還？',
  },

  campusManagement: {
    tabs: {
      facilities: '場地管理',
      approvals: '預約審批',
      settings: '設定',
    },
    exportCsv: '匯出 CSV',
    importCsv: '匯入 CSV',

    facilityId: '場地編號',
    location: '地點',
    building: '大樓',
    floor: '樓層',
    facilityName: '場地名稱',
    capacity: '容量',
    status: '狀態',
    rules: '規則',
    actions: '操作',
    noFacilities: '尚未設定任何可預約場地。',
    autoApprove: '自動批准',
    requiresReview: '需要審批',

    editFacility: '編輯場地',
    addFacility: '新增可預約場地',
    facilityIdPlaceholder: '留空會自動編配',
    locationCode: '地點代碼',
    selectLocation: '— 請選地點 —',
    capShort: '容量：{capacity}',
    available: '可預約',
    unavailable: '暫停預約',
    approvalType: '審批方式',
    requiresAdminApproval: '需要管理員批准',
    autoApproveRequests: '自動批准申請',
    saveFacility: '儲存場地',

    bookingId: '預約編號',
    user: '申請人',
    dateTime: '日期及時間',
    noBookings: '找不到任何預約。',
    remarks: '備註：{remarks}',
    approve: '批准',
    reject: '拒絕',

    addFailed: '新增場地出錯：{message}',
    imported: '匯入完成。成功 {ok} 項，失敗 {failed} 項。',
    parseFailed: '解析 CSV 出錯：{message}',
    deleteConfirm: '刪除此場地？',
    deleteFailed: '刪除出錯：{message}',
    error: '錯誤：{message}',
  },

  examScope: {
    tabs: {
      scopes: '考試範圍',
      toApprove: '待我審批',
      toApproveCount: '待我審批（{count}）',
    },
    newScope: '新增範圍',
    allYears: '所有學年',
    allAssessments: '所有評估',
    allSubjects: '所有科目',
    allLevels: '所有級別',
    anyStatus: '所有狀態',
    searchWording: '搜尋內容…',
    noScopes: '尚未有任何溫習範圍。',
    nothingMatches: '沒有項目符合這些篩選。',
    nothingWaiting: '沒有項目等待你處理。',
    notAPanelHead: '你不是科主任，所以不會有項目送到你這裡審批。科主任在「教學職務」裡面設定。',

    statuses: {
      draft: '草稿',
      pending: '等待審批',
      approved: '已發布',
      rejected: '已退回',
    },
    actions: {
      drafted: '草擬',
      submitted: '提交',
      edited: '修改',
      approved: '批准',
      sentback: '退回',
      editedafterpublication: '發布後修改',
    },

    submittedBy: '由 {name} 提交',
    approvedBy: '由 {name} 批准',
    copyToNew: '複製成新範圍',
    edit: '編輯',
    submitForApproval: '提交審批',
    sendBack: '退回',
    approveAndPublish: '批准並發布',

    editScope: '編輯溫習範圍',
    newScopeTitle: '新溫習範圍',
    schoolYear: '學年',
    assessment: '評估',
    subject: '科目',
    classLevel: '級別',
    noDepartment: '此科目未編入任何部門，所以沒有科主任，只有系統管理員才能發布。請在「系統設定 → 學務 → 開設科目」設定部門。',
    noApprover: '「{department}」在「教學職務」裡面沒有人標示為主任或副主任，所以要系統管理員才能發布。',
    scope: '範圍',
    scopePlaceholder: '章節、課題、頁數範圍…',
    saveAsDraft: '儲存為草稿',
    saveChanges: '儲存變更',

    whySendBack: '退回給作者。原因？',
    saveFailed: '無法儲存：{message}',
    decideFailed: '無法記錄：{message}',
    submitFailed: '無法提交：{message}',
    deleteConfirm: '刪除 {level} 的{subject}溫習範圍？',
    deleteFailed: '刪除不到：{message}',
  },

  dutyRoles: {
    head: '主任',
    deputy: '副主任',
    member: '成員',
  },

  duty: {
    tabs: {
      overview: '總覽',
      assignment: '編配',
    },
    noYears: '找不到學年',
    assign: '編配',
    importCsv: '匯入 CSV',
    exportCsv: '匯出 CSV',

    editAssignment: '編輯編配',
    manualAssignment: '人手編配',
    staff: '教職員',
    role: '職位',
    selectStaff: '選擇教職員…',
    update: '更新',

    recordId: '記錄編號',
    staffInitial: '教職員縮寫',
    lastUpdate: '最後更新',
    updatedBy: '由：{initial}',
    noAllocations: '在已選的條件下找不到任何人手編配。',
    noAssignments: '此篩選之下沒有任何編配。',
    deleteAssignment: '刪除編配',

    deleteConfirm: '確定要移除本項編配？',
    assignFailed: '編配教職員時出錯：{message}',
    updateFailed: '更新教職員時出錯：{message}',
    deleteFailed: '刪除編配時出錯：{message}',
    nothingToExport: '沒有資料可以匯出',
    imported: '成功匯入 {count} 項編配。',
    importFailed: '匯入 CSV 時出錯：{message}',
    parseFailed: '讀取 CSV 時出錯：{message}',
    badYear: '第 {row} 行驗證失敗：School Year「{value}」無效。',
    badInitial: '第 {row} 行驗證失敗：Staff Initial「{value}」無效。',
    badRole: '第 {row} 行驗證失敗：Role「{value}」無效。',
  },

  adminDuty: {
    allCommittees: '所有委員會',
    committee: '委員會',
    selectCommittee: '選擇委員會…',
    committeeCode: '委員會代碼',
    noValidRows: 'CSV 裡面找不到有效資料。請確認欄位和匯出格式一致（School Year、Committee Code、Staff Initial、Role）。',
    badCommittee: '第 {row} 行驗證失敗：Committee Code「{value}」無效。',
  },

  teachingDuty: {
    allDepartments: '所有部門',
    department: '部門',
    selectDepartment: '選擇部門…',
    departmentCode: '部門代碼',
    noValidRows: 'CSV 裡面找不到有效資料。請確認欄位和匯出格式一致（School Year、Department Code、Staff Initial、Role）。',
    badDepartment: '第 {row} 行驗證失敗：Department Code「{value}」無效。',
  },

  salaryAudit: {
    tabs: {
      teacher: '教師薪酬',
      staff: '職員薪酬',
      payscale: '薪級表',
      settings: '設定',
    },

    modes: {
      monthly: '月薪',
      daily: '日薪',
      hourly: '時薪',
      others: '其他',
    },
    units: {
      monthly: '-',
      daily: '日數',
      hourly: '時數',
      others: '-',
    },

    noAccessTitle: '你沒有權限開「薪酬審核」',
    noAccessBody: '薪酬資料受限制。請聯絡系統管理員在此模組的「設定」分頁給權限你。',

    importCsv: '匯入 CSV',
    exportCsv: '匯出 CSV',
    exportForBanking: '匯出 CSV（電子銀行過數用）',
    addPoint: '新增薪點',

    teacherHeading: '教師薪酬 — {month}',
    staffHeading: '職員薪酬 — {month}',
    noPayScale: '尚未定過薪級表 — 請先在「薪級表」分頁設定薪點。',
    noTeachers: '找不到任何教學人員。',
    noStaff: '找不到任何非教學人員。',

    initial: '縮寫',
    mode: '計算方式',
    salaryPoint: '薪點',
    amount: '金額',
    basicRate: '底薪／單價',
    qty: '數量',
    otHours: '超時時數',
    otRate: '超時單價',
    remark: '備註',
    selectPlaceholder: '— 請選擇 —',
    manual: '自行輸入',
    totalTeachers: '總計（{count} 位教師）',
    totalStaff: '總計（{count} 位職員）',

    payScaleTitle: '薪級表',
    payScaleIntro: '用月薪計算的教師會引用這裡的薪點。',
    noPoints: '尚未定過任何薪點。撳「新增薪點」開一個。',
    pointPlaceholder: '例如 1',

    moduleAccess: '模組權限',
    moduleAccessIntro: '在這裡列明的職員可以開「薪酬審核」，並且看到每位同事的薪酬。系統管理員永遠有權限。該名單在「權限控制 → 模組管理員」設定，該份才是安全規則會讀的唯一一份。',
    authorisedStaff: '已授權職員（{count}）',
    noneAuthorised: '沒有 — 只有系統管理員開啟本模組。',
    referenceOnly: '這裡只僅供參考。在兩個地方改，就即請兩份副本自己嗌交，而規則只會跟另外一份。',

    loadFailed: '載無法進入薪酬記錄：{message}',
    salarySaved: '薪酬記錄已儲存。',
    payScaleSaved: '薪級表已儲存。',
    saveFailed: '無法儲存：{message}',
    pointsMustBeUnique: '薪點不可以重複。',
    everyRowNeedsPoint: '每一行都要有薪點。',
    csvNoRows: 'CSV 檔沒有任何資料行。',
    importFailed: '匯入 CSV 失敗：{message}',
    importedSalary: '匯入完成：{month} 更新了 {count} 行。',
    importedSkipped: '{count} 行略過了 — 對應不到人事檔案：{names}',
    importedPayScale: '匯入完成：新增 {added} 項，更新 {updated} 項。',
    importedPayScaleSkipped: '{count} 行略過了（沒有薪點）。',
    clickSaveToPersist: '撳「儲存」先會寫入。',
  },

  formsApp: {
    tabs: {
      myApplication: '我的申請',
      dforms: 'D-Forms',
      documents: '文件',
      approve: '審批',
      settings: '設定',
    },

    statuses: {
      pending: '待審批',
      approved: '已批准',
      rejected: '已拒絕',
    },
    allStatuses: '全部',

    newApplication: '新增申請',
    saveSettings: '儲存設定',

    date: '日期',
    title: '標題',
    description: '說明',
    attachment: '附件',
    approverRemarks: '審批人備註',
    submittedBy: '申請人',
    noApplications: '你尚未交過任何申請。',
    noMatchingApplications: '此篩選之下沒有任何申請。',
    approve: '批准',
    reject: '拒絕',

    noDforms: '尚未設定過任何 D-Form。',
    openForm: '開啟表格',
    noDocuments: '尚未上載過任何文件。',

    categoriesCount: '分類（{count}）',
    categoriesIntro: '用來在 D-Forms 和文件兩個分頁裡面將項目分組。',
    noCategories: '尚未有任何分類 — 些項目會顯示在「未分類」下面。',
    categoryPlaceholder: '例如 人事、學生事務',
    uncategorized: '未分類',
    dformsCount: 'D-Forms（{count}）',
    documentsCount: '文件（{count}）',
    titleChinese: '中文標題',
    link: '連結',
    category: '分類',
    noCategoryOption: '-- 沒有分類 --',
    noDformsYet: '尚未有任何 D-Form。',
    noDocumentsYet: '尚未有任何文件。',
    dformTitlePlaceholder: '例如 請假申請',
    documentTitlePlaceholder: '例如 教職員手冊',
    upload: '上載',

    titleLabel: '標題',
    attachmentOptional: '附件（可選）',
    remarksOptional: '備註（可選）',
    submitting: '正在提交…',
    approveApplication: '批准申請',
    rejectApplication: '拒絕申請',
    confirmApproved: '確認批准',
    confirmRejected: '確認拒絕',
    byLine: '由 {name} 提交',

    wrongDocx: 'Word 該格請選一個 .docx 檔。',
    wrongPdf: 'PDF 該格請選一個 .pdf 檔。',
    uploadFailed: '上載檔案失敗：{message}',
    settingsSaved: '設定已儲存。',
    saveSettingsFailed: '儲存設定失敗：{message}',
    enterTitle: '請輸入標題。',
    submitFailed: '提交申請失敗：{message}',
    deleteConfirm: '刪除本項申請？此動作復原不到。',
    deleteFailed: '刪除申請失敗：{message}',
    decisionFailed: '儲存審批結果失敗：{message}',
  },

  modulePermissions: {
    records: {
      calendar_admin: '校曆同學年',
      timetable_profiles: '時間表版本',
      inventory_admin: '物資目錄',
      manage_it_assets: '資訊科技資產登記冊',
      campus_management: '校舍設施',
      forms_and_application: '表格範本和設定',
      maintenance_report: '維修設定',
    },
    actions: {
      inventory_admin: '審批物資申請',
      manage_it_assets: '批准或拒絕器材預約',
      campus_management: '批准或拒絕場地預約',
      forms_and_application: '審批申請',
      maintenance_report: '派工及結案',
    },

    buckets: {
      admin: '系統管理員',
      teacher: '教師',
      staff: '非教學人員',
    },
    alwaysSuffix: '— 永遠可以',
    role: '角色',
    others: '其他',
    namedInAccessControl: '在「權限管理 → 模組管理員」裡面指定',

    editTitle: '誰可以更改{records}',
    editIntro: '系統管理員永遠可以。剔一個角色，就等於給該角色的所有人都可以新增、修改和刪除{records}。',
    namedInAdmins: '不論角色都需要此權限的個別人士，在「權限管理 → 模組管理員」裡面指定。',
    approveTitle: '誰可以{action}',
    approveIntro: '這與上面一條是兩件事。一個人可以負責維持記錄整齊，但不一定是拍板說「批准」的人。模組管理員永遠都可以{action}。',

    moduleAdminsCount: '模組管理員（{count}）',
    noneNamed: '未指定任何人。',
    adminsReference: '這裡只僅供參考。本該名單只可以由系統管理員在「權限管理」設定 — 一個可以修改其模組管理員，可以將自己加入其他每一個模組。',

    loadingPermissions: '正在載入權限設定…',
    readOnly: '你可以查看此設定，但無法修改。請聯絡系統管理員，或申請成為此模組的管理員。',
    saved: '權限已儲存。',
    saveFailed: '無法儲存：{message}',
  },

  maintenance: {
    tabs: {
      myReport: '我的報修',
      followUp: '跟進',
      settings: '設定',
    },

    statuses: {
      submitted: '已提交',
      inprogress: '處理中',
      complete: '已完成',
    },

    newReport: '新增',
    loadingRecords: '正在載入記錄…',

    editReport: '編輯報修',
    submitNewReport: '提交新報修',
    location: '地點',
    selectLocation: '請選一個地點',
    description: '說明',
    photoOptional: '相片（可選）',
    id: '編號',
    date: '日期',
    photo: '相片',
    noReports: '找不到任何報修。',
    fillRequired: '請填齊所有必填欄位。',
    submitFailed: '提交報修失敗。',
    deleteConfirm: '確定要刪除此報修？',
    deleteFailed: '刪除報修失敗。',

    issue: '問題',
    submitBy: '報修人',
    handleBy: '負責人',
    selectStaff: '選擇教職員',
    finalPrice: '最終價錢',
    pricePlaceholder: '例如 150.00',
    price: '價錢',
    quotationFiles: '報價檔案',
    quotationFilesCount: '報價檔案（{count}/5）',
    quotationNumbered: '報價 {number}',
    deleteFile: '刪除檔案',
    noRecords: '找不到任何記錄。',
    quotationLimit: '每一筆記錄最多只可以有 5 個報價檔案。',
    deleteQuotationConfirm: '確定要刪除此報價檔案？',
    deleteQuotationFailed: '刪除報價檔案失敗。',
    updateFailed: '更新記錄失敗。',

    accessControlSettings: '權限設定',
    saveSettings: '儲存設定',
    maintenanceAdmin: '維修管理員',
    whoCanReport: '誰可以報修？',
    selectStaffOption: '-- 選擇教職員 --',
    allStaff: '全體教職員',
    settingsSaved: '設定已成功儲存。',
    settingsSaveFailed: '儲存設定失敗。',
  },

  assessment: {
    tabs: {
      data: '資料',
      settings: '設定',
    },

    searchSid: '搜尋 SID…',
    exportCsv: '匯出 CSV',
    importCsv: '匯入 CSV',

    showingRecords: '顯示第 {from} 至 {to} 筆，共 {total} 筆',
    perPage: '每頁：',
    prev: '上一頁',
    next: '下一頁',
    pageOf: '第 {current} / {total} 頁',
    noRecords: '找不到任何記錄。',

    saveSettings: '儲存設定',

    gradeMapping: '等級對應',
    gradeStrategy: '等級判定方式：',
    useRawGrade: '直接用原始資料的等級',
    recalculateGrade: '按 ref_mark 重新判定等級',
    rank: '級序',
    fail: '不及格',
    refMark: '參考分數（>）',
    grade1: '等級 1',
    grade2: '等級 2',
    grade3: '等級 3',
    action: '操作',
    noGradeRows: '尚未加過任何等級對應。',
    addGradeRow: '新增等級',

    subjectCodeMapping: '科目代碼對應',
    findUnconverted: '尋找未轉換的代碼',
    convertSamsToSubj: '將 SAMS Code 轉做 SUBJ Code',
    customSubjectMapping: '自訂科目對應',
    customSubjectMappingIntro: '將由 CSV 匯入、尚未轉換的 SAMS Code 對應到你系統的 Subject Code。',
    samsCodeFromCsv: 'SAMS Code（來自 CSV）',
    subjectCodeInternal: 'Subject Code（系統內部）',
    noCustomMappings: '尚未加過任何自訂對應。',
    samsCodePlaceholder: '例如 101',
    subjCodePlaceholder: '例如 ENG',
    addCustomMapping: '新增自訂對應',

    systemParameters: '系統參數（標準對應）',
    systemParametersIntro: '當一個 SAMS Code 可對應多於一個科目時，指定誰科目代碼才是標準該。',
    samsCode: 'SAMS Code',
    subjectCode: 'Subject Code',
    standardTarget: '標準轉換目標',
    noSystemParameters: '找不到任何系統科目參數。',

    fullMarkSetting: '滿分設定',
    fullMarkIntro: '為每個 Subject Code 設定滿分，方便計算百分比。',
    fullMark: '滿分',
    noSubjectCodes: '找不到任何科目代碼。請先設定系統科目，或先做科目對應。',
    fullMarkPlaceholder: '例如 100',

    settingsSaved: '設定已成功儲存！',
    settingsSaveFailed: '儲存設定失敗：{message}',
    noUnconverted: '在現有資料裡面找不到新的未轉換代碼。',
    foundUnconverted: '尋找到並加了 {count} 個未轉換代碼入表。',
    convertConfirm: '確定要按現有的對應，將已匯入資料裡面的 SAMS Code 轉換？此動作會影響現在已選的學年。',
    converted: '成功轉換了 {count} 筆記錄。',
    convertFailed: '轉換途中出錯：{message}',
    csvNoData: 'CSV 裡面找不到資料。',
    imported: '成功分 {count} 批匯入資料。',
    importFailed: '匯入途中出錯：{message}',
    parseFailed: '讀取 CSV 時出錯：{message}',
    selectYearFirst: '請先選一個學年。',
    exportingTemplate: '已選該學年沒有現有資料，改為匯出一個範本樣本。',
    exportFailed: '匯出資料時出錯：{message}',
  },

  talentBankReport: {
    tabs: {
      academic: '學業',
      ole: 'OLE 記錄',
      behaviour: '操行',
    },

    yearFilter: '學年',
    assessmentFilter: '評估',
    loadingAcademic: '正在載入學業記錄…',
    loadingOle: '正在載入 OLE 記錄…',
    loadingBehaviour: '正在載入操行記錄…',
    selectAll: '全選',
    clearAll: '全部清除',

    academicTrend: '學業趨勢',
    metricPercent: '佔滿分百分比',
    metricRank: '名次',
    metricGrade: '等級',
    selectSubjects: '選擇科目',
    compareAssessments: '比較評估',
    selectSubjectsToView: '選擇科目先看到趨勢。',
    selectOneAssessment: '最少選一個評估才能比較。',

    swotAnalysis: 'SWOT 分析',
    strengths: '強項',
    weaknesses: '弱項',
    opportunities: '機會',
    threats: '隱憂',
    swotPercent: '{subject}（{percent}%）',
    swotBorderline: '{subject}（臨界）',
    swotCoreRisk: '{subject}（核心科目風險）',
    classificationCriteria: '分類準則：',
    criteriaDetail: '強項（≥75% 或頭 10 名）• 弱項（<50%）• 機會（臨界 45-49%）• 隱憂（核心科目 <40%）',

    detailedAnalysis: '詳細分析',
    byPercent: '按百分比',
    byRank: '按名次',
    byGrade: '按等級',
    noDataForFilters: '已選的篩選之下沒有資料。',

    rawData: '原始資料',
    sortBySubject: '按科目排序',
    sortByRank: '按名次排序',
    sortByGrade: '按等級排序',
    year: '學年',
    assessment: '評估',
    subject: '科目',
    mark: '分數',
    grade: '等級',
    rank: '名次',
    noRecordsForFilters: '已選的篩選之下沒有任何記錄。',

    oleSummary: 'OLE 參與總覽',
    selectNatures: '選擇性質',
    allNaturesTitle: '所有性質的總時數',
    all: '全部',
    selectNaturesToView: '選擇性質（或「全部」）先看到逐個學年的時數。',
    hoursSuffix: '{hours} 小時',
    oleActivityDetails: 'OLE 活動詳情',
    activity: '活動',
    role: '崗位',
    achievement: '成就',
    activityId: '活動編號：',
    dateTime: '日期／時間：',
    organization: '主辦機構：',
    venue: '地點：',
    staffInCharge: '負責老師：',
    accompanyingStaff: '隨行老師：',
    descriptionLabel: '說明：',

    netBalanceByYear: '各學年淨分',
    awardSummary: '獎勵總覽',
    punishmentSummary: '懲處總覽',
    count: '次數',
    noAwardRecords: '沒有獎勵記錄。',
    noPunishmentRecords: '沒有懲處記錄。',
    recordDetails: '記錄詳情',
  },

  quizTutorial: {
    tabs: {
      quiz: '測驗',
      tutorial: '補課',
      groups: '群組',
      settings: '設定',
    },

    byGroup: '-- 用群組加 --',
    searchStudents: '搜尋學號、姓名、班別…',
    selectAllInClass: '全選 {className}（{count}）',
    selectAllFiltered: '全選（已篩選）（{count}）',
    noMatchingStudents: '沒有符合的學生。',
    noStudentsSelected: '未選擇任何學生。',
    noStudents: '沒有學生。',
    overDailyLimit: '超出每日上限',

    subject: '科目',
    description: '說明',
    submittedBy: '提交人',
    submittedAt: '提交時間',
    noQuizzes: '尚未編排過任何測驗（{year}）。',
    noTutorials: '尚未編排過任何補課（{year}）。',
    thisYear: '本學年',
    noYearsConfigured: '未設定過任何學年',
    addQuiz: '新增測驗',
    addTutorial: '新增補課',
    editQuiz: '編輯測驗',
    editTutorial: '編輯補課',

    groupName: '群組名稱',
    addGroup: '新增群組',
    editGroup: '編輯群組',
    studentsInvolved: '參與學生',
    selectSubject: '-- 選擇科目 --',

    quizThreshold: '測驗每日上限',
    tutorialThreshold: '補課每日上限',
    maxPerDay: '每日最多',
    whenExceeded: '超出時',
    warnOnly: '只作警告',
    rejectSave: '拒絕儲存',
    moduleAdmin: '模組管理員',
    canEditSettings: '可以改設定',

    saveSettingsFailed: '儲存設定失敗：{message}',
    overLimitQuiz: '無法儲存：這樣會令 {count} 位學生超出每日測驗上限（最多 {max} 個／日）— {names}',
    overLimitTutorial: '無法儲存：這樣會令 {count} 位學生超出每日補課上限（最多 {max} 個／日）— {names}',
    saveFailed: '無法儲存：{message}',
    deleteRecordConfirm: '刪除本筆記錄？此動作復原不到。',
    deleteFailed: '刪除不到：{message}',
    saveGroupFailed: '儲存群組失敗：{message}',
    deleteGroupConfirm: '刪除此群組？此動作復原不到。',
  },

  landing: {
    product: '校政通',
    headline: '每間學校，一個屬於自己的平台。',
    subhead: '學籍、考勤、時間表、校園與家長通告集於一處，使用貴校自己的網址，換上貴校自己的名字。',
    ownApp: {
      title: '平台屬於學校，不是屬於我們',
      intro: '學校不應該只是別人名單上的一行。每間學校都有自己的網址，由首至尾都是自己的名字。',
      points: {
        address: {
          title: '專屬網址',
          body: '可以是子網域，也可以是學校自己持有、指向這裡的網域。教職員與家長不會經過列有其他學校的名單。',
        },
        homeScreen: {
          title: '主畫面上是貴校的名字',
          body: '加入手機主畫面後，顯示的是學校的名稱與校徽——就是學校自己的應用程式。',
        },
        data: {
          title: '資料各自分開',
          body: '所有記錄都存於所屬學校之下，學校以外的帳戶無法讀取。',
        },
      },
    },
    modules: {
      title: '包含的範圍',
      intro: '一間學校一星期的行政工作，集於一處，不再散落於一堆表格之中。',
      groups: {
        people: {
          title: '學生與教職員',
          body: '學籍及教職員資料、家長帳戶、按角色區分的登入與權限，以及跟隨學生歷年的才能庫。',
        },
        daily: {
          title: '日常校務',
          body: '考勤與請假、獎懲記錄、監考（含特殊考場）、巡邏職務與座位表。',
        },
        timetable: {
          title: '時間表與代課',
          body: '教節分配、缺勤時的代課安排、校曆，以及每位同事自己的時間表與職務。',
        },
        campus: {
          title: '校園與資產',
          body: '場地與設施預約、物資清單、裝置管理，以及由發現者直接遞交的維修報告。',
        },
        finance: {
          title: '預算與薪酬',
          body: '各科組預算與實際開支對照，以及假期、薪點與薪酬核對的完整記錄。',
        },
        contact: {
          title: '通告與訊息',
          body: '家長通告及簽名回條（連尚未交的一併列出）、教職員之間的訊息，以及各類表格與申請。',
        },
      },
    },
    cta: {
      title: '讓貴校也用上',
      body: '開校只需提供網址、校徽與教職員名單，其餘由我們處理，學校由第一天起就在自己的平台上運作。',
      action: '預約示範',
      email: 'sales@example.com',
    },
    footer: {
      line: '為香港學校而設。',
    },
  },

  talentBank: {
    selectStudentTitle: '選一位學生查看其資料',
    searchHint: '在上面用學號、姓名或班別搜尋。',
    searchStudents: '搜尋學生',
    unknownName: '姓名不詳',
  },

  sessionDates: {
    addADay: '加一日',
    fillRange: '填一段日期 — 不剔星期幾就是範圍內每一日',
    to: '至',
    daysSelected: '已選 {count} 日',
    lockedNote: '{count} 日已經有點名記錄，無法刪除',
    noDays: '尚未選擇日子。一個活動最少要有一日，先會有場次。',
  },

  budget: {
    tabs: {
      statistics: '統計',
      budget: '預算',
      expenditure: '支出',
      settlement: '結算',
      settings: '設定',
    },

    settledStatuses: {
      pending: '待處理',
      settled: '已結算',
      rejected: '已拒絕',
    },
    budgetStatuses: {
      applied: '已申請',
      approved: '已批准',
      rejected: '已拒絕',
    },
    accessLevels: {
      edit: '可編輯',
      viewonly: '只可檢視',
      noaccess: '沒有權限',
    },

    sortAsc: '順序排列',
    sortDesc: '倒序排列',
    noValues: '沒有數值',
    clearFilter: '清除篩選',

    searchRecords: '搜尋記錄…',
    exportCsv: '匯出 CSV',
    importCsv: '匯入 CSV',
    exportBudgetCsv: '匯出預算 CSV',
    importBudgetCsv: '匯入預算 CSV',
    newRecord: '新增',

    expId: '支出編號',
    budgetId: '預算編號',
    autoAssigned: '自動編配',
    selectYear: '— 選擇學年 —',
    invoiceDate: '發票日期',
    deptCode: '部門代碼',
    selectDept: '— 選擇部門 —',
    committeeGroup: '——— 委員會 ———',
    subjectsGroup: '——— 科目 ———',
    itemDescription: '項目說明',
    tic: 'TIC',
    selectTic: '— 選擇 TIC —',
    fundCode: '基金代碼',
    selectFund: '— 選擇基金 —',
    amount: '金額',

    perPage: '每頁：',
    selectField: '選擇欄位…',
    selectValue: '選擇數值…',
    prev: '上一頁',
    next: '下一頁',

    statisticsTitle: '預算統計',
    deptCommitteeLabel: '部門／委員會：',
    fundingLabel: '基金：',
    deptCommittee: '部門／委員會',
    totalBudgetApproved: '預算總額（已批准）',
    totalExpenditure: '支出總額',
    remainingBalance: '餘額',

    invDate: '發票日期',
    deptTic: '部門／TIC',
    deptTicSpaced: '部門／TIC',
    item: '項目',
    amt: '金額',
    created: '建立',
    updated: '更新',
    method: '付款方式',
    transNo: '交易編號',
    methods: {
      autopay: '自動轉賬',
      cheque: '支票',
      cash: '現金',
      banktransfer: '銀行轉賬',
      others: '其他',
    },
    noExpenditureRecords: '找不到任何支出記錄。',
    invoice: '發票',
    receipt: '收據',
    noRecords: '找不到任何記錄。',
    link: '連結',
    urlPlaceholder: '網址',

    settingsTitle: '預算管理設定',
    roleMatrix: '角色權限矩陣',
    area: '範圍',
    globalRoles: '全域角色',
    accountants: '學校會計（可編輯所有記錄）',
    budgetAdmins: '預算管理員（可編輯所有記錄）',
    selectStaff: '— 選擇教職員 —',
    noAccountants: '未指派任何會計。',
    noBudgetAdmins: '未指派任何預算管理員。',

    logTitle: '記錄',
    startDate: '開始日期',
    endDate: '結束日期',
    logType: '記錄類型',
    logBoth: '兩者',
    exporting: '正在匯出…',
    exportLogCsv: '匯出記錄 CSV',

    settingsSaved: '設定已成功儲存！',
    settingsSaveFailed: '儲存設定失敗',
    deleteRecordConfirm: '刪除本筆記錄？',
    deleteBudgetConfirm: '刪除本筆預算記錄？',
    cannotDeleteSettled: '已結算或已拒絕的支出記錄，你無法刪除。',
    cannotDeleteApproved: '已批准的預算記錄，你無法刪除。',
    cannotEditSettled: '已結算或已拒絕的支出記錄，你無法修改。',
    cannotEditApproved: '已批准的預算記錄，你無法修改。',
    deleteFailed: '刪除時出錯：{message}',
    saveFailed: '儲存時出錯：{message}',
    saveSettlementFailed: '儲存結算時出錯：{message}',
    saveBudgetFailed: '儲存預算時出錯：{message}',
    parseFailed: '讀取 CSV 時出錯：{message}',
    exportLogsFailed: '匯出記錄時出錯：{message}',
    noLogs: '已選的條件下找不到任何記錄。',

    badFundCode: '第 {row} 行驗證失敗：Fund Code「{value}」無效或沒有填。已中止匯入。',
    badDeptCode: '第 {row} 行驗證失敗：Dept Code「{value}」無效或沒有填。已中止匯入。',
    noEditPermission: '第 {row} 行拒絕存取：你沒有 Dept Code「{value}」的編輯權限。已中止匯入。',
    badStatus: '第 {row} 行驗證失敗：Status「{value}」無效。已中止匯入。',
    importComplete: '匯入完成。成功 {ok} 筆，失敗 {failed} 筆。',
    budgetImportComplete: '預算匯入完成。成功 {ok} 筆，失敗 {failed} 筆。',
    systemFieldsNote: '注意：「Status」、「Created By」、「Created At」、「Updated By」和「Updated At」此幾個欄位由系統自動記錄。CSV 裡面對這些欄位的改動一律略過。',

    deleteExpendituresConfirm: '刪除 {count} 筆支出記錄？',
    deleteBudgetsConfirm: '刪除 {count} 筆預算記錄？',
    batchUpdateExpenditures: '將 {count} 筆支出記錄的 {field} 更新做「{value}」？',
    batchUpdateBudgets: '將 {count} 筆預算記錄的 {field} 更新做「{value}」？',
  },

  ole: {
    deleteActivityConfirm: '刪除活動「{title}」（{id}）？',
    deleteActivityPortfolios: ' 該活動亦會從 {count} 位學生的個人檔案中移除。',
    cannotBeUndone: ' 此動作無法復原。',
    tabs: {
      activity: '活動',
      portfolio: '個人檔案',
      leaders: '學生領袖',
      notices: '通告',
      template: '範本',
      settings: '設定',
    },

    attendance: {
      present: '出席',
      absent: '缺席',
      pending: '未點名',
    },

    noMatches: '沒有符合的結果',
    seq: '次序',
    noItems: '尚未有任何項目。',
    moveUp: '上移',
    moveDown: '下移',
    sortFilter: '排序／篩選',
    sort: '排序',
    filter: '篩選',
    asc: '順序',
    desc: '倒序',
    filterPlaceholder: '篩選{label}…',
    example: '例如 {value}',

    activityId: '活動編號',
    title: '名稱',
    dateTime: '日期／時間',
    organization: '主辦組別',
    nature: '性質',
    staffInCharge: '負責老師',
    role: '崗位',
    activity: '活動',
    achievement: '成就',
    achievementAward: '成就／獎項',
    venue: '地點',
    accompanyingStaff: '隨行老師',
    descriptionLabel: '說明',
    classNo: '學號',
    file: '檔案',
    lastUpdated: '最後更新',

    addActivity: '新增活動',
    editActivity: '編輯活動（{id}）',
    importing: '正在匯入…',
    importCsv: '匯入 CSV',
    exportCsv: '匯出 CSV',
    noYearsConfigured: '未設定過任何學年',
    participantRole: '參加者崗位',
    printDocument: '列印文件',
    takeAttendance: '點名',
    issueNotice: '發出通告',
    copyActivity: '複製活動',

    pickStudent: '選一個班別同學生，查看其 OLE 個人檔案。',
    noPortfolio: '這位學生沒有任何 OLE 活動記錄。',

    templatesTitle: 'OLE 文件範本',
    createTemplate: '新增範本',
    editTemplate: '編輯範本',
    templateName: '範本名稱',
    descriptionOptional: '說明（可選）',
    uploadDocx: '上載 .docx 檔',
    replaceFile: '更換檔案（可選）',
    sampleHint: '第一次用？由一個列齊所有欄位的樣本開始。',
    downloadSample: '下載樣本範本',
    sampleDocTitle: 'OLE 文件範本樣本',
    sampleDocIntro: '這是一個起點。在本份文件任何地方打下面任何一個標籤（連大括號），發出文件時就會換成真實資料。刪了此段字，然後照你自己的意思排版，排好再重新上載。',
    print: '列印',
    download: '下載',
    downloading: '正在下載…',
    downloadDocx: '下載 .docx',
    preview: '預覽',
    selectTemplate: '— 選一個範本 —',
    startFromTemplate: '由範本開始 — 活動自己的資料會自動填入：',
    participantOptional: '參加者（可選）',

    saveSettings: '儲存設定',
    organizations: '主辦組別',
    natureTitle: '性質',
    participantRoles: '參加者崗位',
    leadersRole: '學生領袖崗位',
    importFromDepartments: '由部門／委員會匯入',
    code: '代碼',
    nameEn: '名稱（英文）',
    nameZh: '名稱（中文）',
    teacherInCharge: '負責老師',

    titleEn: '活動名稱（英文）',
    titleZh: '活動名稱（中文）',
    descriptionEn: '活動說明（英文）',
    descriptionZh: '活動說明（中文）',
    dates: '日期',
    startTime: '開始時間',
    endTime: '結束時間',
    venueEn: '地點（英文）',
    venueZh: '地點（中文）',
    searchStaff: '搜尋教職員…',
    submitReplyTo: '回條交給',
    submitByDate: '交回限期',
    saveChanges: '儲存變更',
    saveAndAddParticipants: '儲存並加入參加者',

    allClasses: '所有班別',
    searchStudents: '搜尋學號、姓名、班別…',
    noMatchingStudents: '沒有符合的學生。',
    saveParticipants: '儲存參加者',
    noParticipantsYet: '此活動尚未有參加者。請先加入參加者。',
    saveRoles: '儲存崗位',

    addLeader: '新增學生領袖',
    editLeader: '編輯學生領袖',

    attendanceTitle: '點名',
    attendanceSubtitle: '{title} — 記錄誰出席了。',
    noDatesYet: '此活動尚未有日期。請先編輯活動、選擇它在邊幾日舉行，先可以點名。',
    session: '場次',

    issueNoticeTitle: '發出通告',
    noticeIntro: '成個活動出一張通告。日期和收件人由活動該處帶過來，不需要重新打過。',
    participantCount: '{count} 位參加者',
    noDatesWarning: '未選擇日期 — 家長會收到一張沒有日期的通告。請先編輯活動。',
    issuedBy: '發出人',
    selectPlaceholder: '請選擇…',
    content: '內容',
    contentPlaceholder: '家長需要知道及要同意的內容。',
    replaceWithTemplate: '用此範本取代現在的文字？',

    copyActivityTitle: '複製活動',
    copyFrom: '來源：「{title}」。',
    copyParticipants: '連參加者名單一齊複製',
    copyRoles: '連他們的崗位一齊複製',
    copyRolesHint: '不剔就是同一批學生，但崗位重新編配',
    notCopiedLabel: '不會複製',
    notCopiedDetail: '：日期、點名和回條簽署。那些屬於被複製該次舉行。複製之後請選擇日期。',
    copying: '正在複製…',
    copy: '複製',

    sampleFailed: '產生樣本範本失敗：{message}',
    codeChangeConfirm: '偵測到代碼有改動：\n\n{summary}\n\n所有使用中舊代碼的活動同學生領袖記錄，都會更新做新代碼。要繼續？',
    settingsSavedCascade: '設定已成功儲存！{count} 筆記錄已跟住代碼改動更新。',
    settingsSaved: '設定已成功儲存！',
    settingsSaveFailed: '儲存設定失敗：{message}',
    nothingToImport: '沒有新的部門／委員會可以匯入 — 所有代碼在「主辦組別」裡面已經存在。',
    sessionsSyncFailed: '活動已儲存，但場次同步不到：{message}',
    noParticipants: '此活動尚未有參加者。',
    writeNoticeFirst: '請先寫通告內容。',
    noticeSubmitted: '通告 {id} 已提交審批。批了之後就會送到該 {count} 個家庭度，並且在「通告」分頁跟進到。',
    noticeFailed: '無法發出通告：{message}',
    copiedTo: '已複製做 {id}。記得選擇日期。',
    copyFailed: '無法複製：{message}',
    titleRequired: '活動名稱（英文或中文）是必填。',
    selectYearFirst: '請先選一個學年。',
    saveActivityFailed: '儲存活動失敗：{message}',
    deleteActivityFailed: '刪除活動失敗：{message}',
    csvNoRows: 'CSV 檔沒有任何資料行。',
    imported: '匯入完成：新增 {added} 項，更新 {updated} 項。',
    importedSkipped: '{count} 項略過了（沒有名稱或沒有學年）。',
    importFailed: '匯入 CSV 失敗：{message}',
    saveParticipantsFailed: '儲存參加者失敗：{message}',
    saveFailed: '儲存失敗：{message}',
    saveRolesFailed: '儲存參加者崗位失敗：{message}',
    leaderFieldsRequired: '請選齊學生組織、崗位同學生。',
    saveLeaderFailed: '儲存學生領袖記錄失敗：{message}',
    removeLeaderConfirm: '移除 {student} 在「{organization}」的「{role}」崗位？',
    deleteLeaderFailed: '刪除學生領袖記錄失敗：{message}',
    templateNameRequired: '請輸入範本名稱。',
    chooseDocx: '請選一個 .docx 檔上載。',
    saveTemplateFailed: '儲存範本失敗：{message}',
    deleteTemplateConfirm: '刪除範本「{name}」？此動作復原不到。',
    deleteTemplateFailed: '刪除範本失敗：{message}',

    variables: {
      activityTitleEn: '活動名稱（英文）',
      activityTitleZh: '活動名稱（中文）',
      activityDescriptionEn: '活動說明（英文）',
      activityDescriptionZh: '活動說明（中文）',
      organizationEn: '主辦組別（英文）',
      organizationZh: '主辦組別（中文）',
      natureEn: '性質（英文）',
      natureZh: '性質（中文）',
      activityDate: '活動日期',
      timeStart: '開始時間',
      timeEnd: '結束時間',
      venueEn: '地點（英文）',
      venueZh: '地點（中文）',
      staffInCharge: '負責老師（英文）',
      staffInChargeZh: '負責老師（中文）',
      replyToStaff: '回條交給（英文）',
      replyToStaffZh: '回條交給（中文）',
      replyDueDate: '交回限期',
      schoolYear: '學年',
      studentName: '學生姓名（英文）',
      studentChineseName: '學生姓名（中文）',
      sid: '學生編號',
      currentClass: '班別',
      classNumber: '班號',
      roleEn: '參加者崗位（英文）',
      roleZh: '參加者崗位（中文）',
      achievement: '成就／獎項',
    },
  },

  layout: {
    switchTenant: '切換租戶',
    welcome: '歡迎使用校政通',
    openMenu: '開啟選單',
    collapseMenu: '收合選單',
    expandMenu: '展開選單',
    openControls: '開啟頁面控制項',
    pageControls: '頁面控制項',
    turnOnNotifications: '開啟通知',
    moduleOff: '模組已停用',
    moduleOffDetail: '此模組已於系統設定中停用。',
    noSchool: '未選擇學校',
  },
};
